import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import './App.css';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

const modules = [
  { id: 'post', label: 'Post Now', meta: 'Compose' },
  { id: 'manage', label: 'Manage Posts', meta: 'Edit' },
  { id: 'calendar', label: 'Calendar', meta: 'Plan' },
  { id: 'messaging', label: 'Messaging', meta: '12 open' },
  { id: 'reports', label: 'Reports', meta: 'Live' },
  { id: 'profiles', label: 'Profiles', meta: 'Connect' },
  { id: 'bulk', label: 'Bulk Scheduling', meta: 'CSV' },
  { id: 'ads', label: 'Ads', meta: 'Meta + Google' }
];

const workspaces = [
  {
    id: 'easten-mediatech',
    name: 'Easten Mediatech',
    initials: 'EM',
    owner: 'Company A',
    plan: 'Growth Suite',
    color: '#246bfe',
    audience: '48.2K',
    queue: 18,
    unread: 12,
    adSpend: '₹18.4K'
  },
  {
    id: 'easten-pariwaar',
    name: 'Easten Pariwaar',
    initials: 'EP',
    owner: 'Company B',
    plan: 'Local Brand',
    color: '#0ea5a4',
    audience: '19.7K',
    queue: 7,
    unread: 4,
    adSpend: '₹6.8K'
  },
  {
    id: 'studio-north',
    name: 'Studio North',
    initials: 'SN',
    owner: 'Company C',
    plan: 'Creator Lab',
    color: '#8b5cf6',
    audience: '83.5K',
    queue: 31,
    unread: 22,
    adSpend: '₹42.1K'
  }
];

const platforms = [
  { id: 'facebook', label: 'Facebook', short: 'FB', mark: 'f', color: '#1877f2', connected: true },
  { id: 'instagram', label: 'Instagram', short: 'IG', mark: 'IG', color: '#e1306c', connected: true },
  { id: 'threads', label: 'Threads', short: 'TH', mark: '@', color: '#111111', connected: false },
  { id: 'google', label: 'Google Business', short: 'GB', mark: 'G', color: '#24a36a', connected: true },
  { id: 'youtube', label: 'YouTube', short: 'YT', mark: '▶', color: '#ff0000', connected: false },
  { id: 'twitter', label: 'X (Twitter)', short: 'X', mark: 'X', color: '#111111', connected: false },
  { id: 'linkedin', label: 'LinkedIn', short: 'IN', mark: 'in', color: '#0a66c2', connected: true }
];

const calendarPosts = [
  { day: 2, time: '10:00', title: 'New branding reveal', platform: 'facebook', status: 'Ready' },
  { day: 2, time: '10:15', title: 'Reveal story set', platform: 'instagram', status: 'Ready' },
  { day: 2, time: '11:00', title: 'Launch short', platform: 'youtube', status: 'Needs media' },
  { day: 4, time: '14:30', title: 'Behind the scene reel', platform: 'instagram', status: 'Review' },
  { day: 7, time: '09:15', title: 'Google offer update', platform: 'google', status: 'Scheduled' },
  { day: 9, time: '18:00', title: 'Founder note', platform: 'linkedin', status: 'Draft' },
  { day: 14, time: '11:30', title: 'Customer story', platform: 'facebook', status: 'Ready' },
  { day: 16, time: '16:45', title: 'Product short', platform: 'youtube', status: 'Needs media' },
  { day: 21, time: '12:00', title: 'Monthly roundup', platform: 'instagram', status: 'Scheduled' },
  { day: 28, time: '17:15', title: 'Lead campaign push', platform: 'linkedin', status: 'Ready' }
];

const inboxItems = [
  {
    id: 1,
    from: 'Amandeep Kaur',
    network: 'Instagram',
    status: 'Unread',
    tag: 'Lead',
    time: '4m',
    body: 'Price list share kar do. Saturday appointment possible hai?',
    sentiment: 'Hot'
  },
  {
    id: 2,
    from: 'Rohit Sharma',
    network: 'Facebook',
    status: 'Follow up',
    tag: 'Support',
    time: '28m',
    body: 'Kal message kiya tha. Demo ka link nahi mila.',
    sentiment: 'Warm'
  },
  {
    id: 3,
    from: 'Simran Studio',
    network: 'Google Business',
    status: 'Unread',
    tag: 'Review',
    time: '1h',
    body: 'Review reply approve karna hai, tone polite rakhna.',
    sentiment: 'Neutral'
  },
  {
    id: 4,
    from: 'Corporate Buyer',
    network: 'LinkedIn',
    status: 'Read',
    tag: 'B2B',
    time: '3h',
    body: 'Can you send the proposal for monthly social management?',
    sentiment: 'Warm'
  }
];

const topPosts = [
  { rank: 1, platform: 'Instagram', post: 'Behind the scenes carousel', reach: '34.8K', engagement: '9.8%', leads: 41 },
  { rank: 2, platform: 'Facebook', post: 'Offer announcement', reach: '28.1K', engagement: '7.6%', leads: 33 },
  { rank: 3, platform: 'Google', post: 'Weekend update', reach: '12.4K', engagement: '5.2%', leads: 19 },
  { rank: 4, platform: 'LinkedIn', post: 'Founder story', reach: '8.9K', engagement: '6.4%', leads: 12 },
  { rank: 5, platform: 'YouTube', post: 'Product short', reach: '7.2K', engagement: '4.9%', leads: 9 }
];

const reportSeries = [
  { label: 'Facebook', color: '#2563eb', values: [22, 35, 28, 44, 58, 52, 68] },
  { label: 'Instagram', color: '#e1306c', values: [34, 42, 49, 45, 66, 72, 81] },
  { label: 'Google', color: '#16a34a', values: [18, 25, 31, 38, 36, 47, 54] },
  { label: 'LinkedIn', color: '#0a66c2', values: [14, 19, 24, 34, 41, 45, 49] }
];

const pricingPlans = [
  {
    name: 'Easten Social Basic',
    badge: 'Free starter',
    channels: '5 Channels',
    price: 'Free',
    note: 'For small creators and single-location teams',
    features: ['Post planning', 'Basic calendar', 'Recent posts log', 'Profile connect center']
  },
  {
    name: 'Easten Social Grow',
    badge: 'Most popular',
    channels: '20 Channels',
    price: '\u20b9999',
    note: 'For growing brands and agencies handling daily content',
    features: ['Everything in Basic', 'Bulk scheduling', 'Reports dashboard', 'Client-ready workflow']
  },
  {
    name: 'Easten Social Pro',
    badge: 'Agency scale',
    channels: '50 Channels',
    price: '\u20b91999',
    note: 'For serious social teams with multiple clients',
    features: ['Everything in Grow', 'Advanced reports', 'Ads control center', 'Priority onboarding']
  }
];

const competitorPlatforms = [
  'Planable',
  'CoSchedule',
  'Sprout Social',
  'Buffer',
  'SocialPilot',
  'HeyOrca',
  'SocialBee',
  'SocialChamp',
  'Postly',
  'Hootsuite',
  'Later',
  'Loomly',
  'Agorapulse',
  'Sendible',
  'Metricool',
  'Zoho Social',
  'Publer',
  'Vista Social',
  'ContentStudio',
  'NapoleonCat'
];

const eastenAdvantages = [
  'Agency workspaces with client switching',
  'Post Now, Calendar, Messaging, Reports, Profiles, Bulk Scheduling and Ads in one dashboard',
  'AI caption workflow for platform-ready copy',
  'Client approval calendar and share-ready reporting',
  'India-first pricing with 5 free channels',
  'Built for Meta, Google, YouTube, LinkedIn and X API workflows'
];

const exclusiveFeatures = [
  ['One Click Post', 'Post on 6 platforms with one click.'],
  ['Manage Posts', 'Edit and delete content you posted.'],
  ['Schedule Post', 'Schedule for each platform separately.'],
  ['Calendar View', 'View scheduled posts for the whole month.'],
  ['Approval Link', 'Share calendar links and get approvals.'],
  ['Single Inbox', 'Messages from all platforms in one place.'],
  ['Post in Bulk', 'Post for a month with one-time setup.'],
  ['Manage Ads', 'Create campaigns for Meta and Google.']
];

const guidedWorkflowSteps = [
  {
    label: 'Step 1',
    title: 'Register/Login',
    text: 'Click Register Now, enter your email and desired password, verify with the one-time code received on your email, then log in to your account.',
    visualTitle: 'Create your workspace',
    chips: ['Register', 'Email OTP', 'Login']
  },
  {
    label: 'Step 2',
    title: 'Connect Profile',
    text: 'Click the profile you want to post on, authorize platform access, and confirm that the profile is connected.',
    visualTitle: 'Connect profiles',
    chips: ['Meta', 'Google', 'YouTube']
  },
  {
    label: 'Step 3',
    title: 'Post/Schedule',
    text: 'Once a profile is connected, add media, write your caption manually or with AI, choose the platform, then post now or schedule it for later.',
    visualTitle: 'Post or schedule',
    chips: ['Add media', 'Write caption', 'Schedule']
  }
];

const partnerBrands = ['AWS', 'Meta', 'LinkedIn', 'X', 'Google'];

const bestReasons = [
  ['Absolutely free', 'Built for brands, SMEs, and agencies that want serious workflow without starting cost.'],
  ['One workspace', 'Plan, post, manage, message, report, and run ads from one simple control center.'],
  ['Secure cloud approach', 'Designed around AWS-grade hosting principles and separated client workspaces.'],
  ['Platform ready', 'Prepared for official API workflows across Meta, Google, YouTube, LinkedIn, and X.']
];

const policyPages = {
  privacy: {
    title: 'Privacy Policy',
    eyebrow: 'Trust center',
    body: [
      'Easten Social collects only the information required to create your workspace, connect social profiles, schedule content, and generate reports.',
      'Connected platform tokens and client data are handled for publishing, analytics, messaging, and approval workflows. We do not sell customer data.',
      'Access is limited to authorized users in your workspace, and future enterprise plans can include additional role-based controls.'
    ]
  },
  'data-deletion': {
    title: 'Data Deletion Policy',
    eyebrow: 'Account control',
    body: [
      'Users can request deletion of workspace data, connected profile data, saved posts, media references, reports, and account records.',
      'When a deletion request is received, Easten Social will disconnect available platform tokens and remove stored workspace data from active systems.',
      'Some logs may remain for limited security, legal, or billing reasons where required.'
    ]
  },
  terms: {
    title: 'Terms & Conditions',
    eyebrow: 'Using Easten Social',
    body: [
      'Easten Social is a social media management platform for agencies, creators, and businesses.',
      'Users are responsible for the content they publish and for maintaining valid permissions on connected social profiles.',
      'Platform availability depends on third-party API access, approvals, quotas, and policy changes from Meta, Google, YouTube, LinkedIn, X and other networks.'
    ]
  },
  disclaimer: {
    title: 'Disclaimer',
    eyebrow: 'Important note',
    body: [
      'Easten Social is built for official platform API workflows, but third-party platforms may change permissions, review requirements, limits, or features at any time.',
      'Brand logos and platform names are used to identify compatibility and integrations. They do not imply ownership by or endorsement from those companies.',
      'Reports and previews are designed to help teams make decisions, but final platform-side results can vary.'
    ]
  },
  contact: {
    title: 'Contact Us',
    eyebrow: 'Talk to us',
    body: [
      'For sales, onboarding, support, or partnership queries, contact Easten Mediatech through eastenmediatech.com.',
      'Agencies can request custom onboarding for multiple workspaces, bulk scheduling, reporting setup, and platform approval assistance.'
    ]
  },
  about: {
    title: 'About Us',
    eyebrow: 'Parent firm',
    body: [
      'Easten Social is created by Easten Mediatech to help agencies and local businesses manage modern social media workflows without scattered tools.',
      'The product focus is simple: connect profiles, create better content, schedule with confidence, reply faster, and report clearly.'
    ]
  }
};

const builderStorageKey = 'easten-social-home-builder-v1';

const builderPalette = [
  { type: 'hero', label: 'Hero' },
  { type: 'features', label: 'Feature Cards' },
  { type: 'text', label: 'Text Block' },
  { type: 'image', label: 'Image/Video Banner' },
  { type: 'table', label: 'Table' },
  { type: 'graphics', label: 'Graphics Cards' },
  { type: 'pricing', label: 'Pricing' }
];

function makeBuilderId(type) {
  return `${type}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function createBuilderSection(type) {
  const id = makeBuilderId(type);

  if (type === 'hero') {
    return {
      id,
      type,
      kicker: 'Built by Easten Mediatech',
      title: 'Easten Social',
      subtitle: 'Automate without limits.',
      body: 'Plan content, publish across channels, manage approvals, reply to customers, and report growth from one premium workspace.',
      buttonText: 'Get Started Now',
      secondaryButtonText: 'View Dashboard'
    };
  }

  if (type === 'features') {
    return {
      id,
      type,
      kicker: 'Complete agency suite',
      title: 'Everything your social media team needs.',
      body: 'Add, remove, and edit feature cards from the builder.',
      cards: [
        { title: 'Post Now', text: 'Publish images, videos, reels, shorts, stories and business updates.' },
        { title: 'Calendar', text: 'Plan monthly content and share approval links with clients.' },
        { title: 'Reports', text: 'Track growth, top posts, ad spend and client-ready reports.' }
      ]
    };
  }

  if (type === 'table') {
    return {
      id,
      type,
      kicker: 'Compare',
      title: 'Easten Social vs other platforms',
      body: 'Editable comparison table.',
      rows: [
        { feature: 'Free starter channels', easten: '5 channels', other: 'Usually limited trial' },
        { feature: 'Agency workflow', easten: 'Built-in', other: 'Depends on plan' },
        { feature: 'Client approval', easten: 'Included', other: 'Often add-on' }
      ]
    };
  }

  if (type === 'image') {
    return {
      id,
      type,
      kicker: 'Product preview',
      title: 'Show a demo, screenshot, or campaign visual.',
      body: 'Paste an image/video URL or upload a small image from your computer.',
      imageUrl: '',
      caption: 'Replace this with your product demo visual.'
    };
  }

  if (type === 'graphics') {
    return {
      id,
      type,
      kicker: 'Visual proof',
      title: 'Make the page feel rich with graphics.',
      body: 'Use these editable graphic cards for metrics, badges, trust points, or process steps.',
      cards: [
        { title: '50 Channels', text: 'Scale to agency-level publishing.' },
        { title: 'AI Captions', text: 'Write faster with assistant workflows.' },
        { title: 'Client Approval', text: 'Keep review loops clean.' }
      ]
    };
  }

  if (type === 'pricing') {
    return {
      id,
      type,
      kicker: 'Plans',
      title: 'Start free, upgrade when the agency grows.',
      body: 'Edit the plan cards anytime.',
      cards: pricingPlans.map((plan) => ({ title: plan.name, text: `${plan.price} - ${plan.channels}` }))
    };
  }

  return {
    id,
    type: 'text',
    kicker: 'Content block',
    title: 'Add your headline',
    body: 'Write the section content here. You can reorder this section, duplicate it, or delete it.'
  };
}

const defaultBuilderSections = [
  createBuilderSection('hero'),
  createBuilderSection('features'),
  createBuilderSection('image'),
  createBuilderSection('table'),
  createBuilderSection('pricing'),
  createBuilderSection('graphics')
];

const adminStats = [
  { label: 'Workspaces', value: '12', note: 'Across agency accounts' },
  { label: 'Connected Channels', value: '38', note: 'Meta, Google, YouTube' },
  { label: 'Queued Posts', value: '146', note: 'Next 30 days' },
  { label: 'Monthly Revenue', value: '\u20b964K', note: 'Subscriptions + services' }
];

const profileCards = [
  { platform: 'Facebook', handle: 'Not connected', health: 'Disconnected', sync: 'Connect now', color: '#2563eb' },
  { platform: 'Instagram', handle: 'Not connected', health: 'Disconnected', sync: 'Connect now', color: '#e1306c' },
  { platform: 'Google Business', handle: 'Not connected', health: 'Disconnected', sync: 'Connect now', color: '#16a34a' },
  { platform: 'LinkedIn', handle: 'Not connected', health: 'Disconnected', sync: 'Connect later', color: '#0a66c2' },
  { platform: 'YouTube', handle: 'Not connected', health: 'Disconnected', sync: 'Connect now', color: '#dc2626' }
];

const bulkRowsSeed = [
  { id: 1, date: '2026-07-03', platform: 'Facebook + Instagram', caption: 'Monsoon offer launch', media: 'image', status: 'Mapped' },
  { id: 2, date: '2026-07-05', platform: 'Google Business', caption: 'Store timing update', media: 'none', status: 'Ready' },
  { id: 3, date: '2026-07-08', platform: 'LinkedIn', caption: 'Team hiring post', media: 'video', status: 'Needs caption' }
];

const adCampaigns = [
  { name: 'Meta Lead Burst', platform: 'Meta Ads', budget: '₹12,000', spent: '₹8,420', result: '86 leads', state: 'Learning' },
  { name: 'Google Local Calls', platform: 'Google Ads', budget: '₹9,500', spent: '₹5,110', result: '42 calls', state: 'Active' },
  { name: 'Retarget Warm Visitors', platform: 'Meta Ads', budget: '₹6,000', spent: '₹2,720', result: '3.8x ROAS', state: 'Scaling' }
];

const calendarYear = 2026;
const calendarMonthIndex = 6;
const calendarLabel = 'July 2026';

function getRedirectNotice() {
  const params = new URLSearchParams(window.location.search);
  const facebookState = params.get('facebook');

  if (facebookState === 'connected') {
    const pages = params.get('pages') || '0';
    const warning = params.get('warning');

    if (warning === 'no_pages') {
      return { type: 'warning', message: 'Facebook connected, but no page came back. Reconnect with the page owner account.' };
    }

    if (warning === 'missing_permissions') {
      return { type: 'warning', message: `Facebook connected and ${pages} page(s) found, but permissions need review.` };
    }

    return { type: 'success', message: `Facebook connected. ${pages} page(s) found.` };
  }

  if (facebookState === 'error') {
    return { type: 'error', message: `Facebook page sync failed: ${params.get('message') || 'unknown error'}` };
  }

  if (facebookState === 'config_error') {
    return { type: 'error', message: `Facebook backend config issue: ${params.get('message') || 'missing settings'}` };
  }

  if (facebookState === 'failed') {
    return { type: 'error', message: 'Facebook login failed. Try Connect Facebook again.' };
  }

  const googleState = params.get('google');

  if (googleState === 'connected') {
    return { type: 'success', message: `Google connected: ${params.get('email') || 'account synced'}.` };
  }

  if (googleState === 'config_error' || googleState === 'session_error' || googleState === 'error') {
    return { type: 'error', message: `Google connection issue: ${params.get('message') || 'unknown error'}` };
  }

  return null;
}

function cx(...names) {
  return names.filter(Boolean).join(' ');
}

function platformById(id) {
  return platforms.find((platform) => platform.id === id) || platforms[0];
}

function monthDays() {
  const days = [];
  for (let i = 0; i < 35; i += 1) {
    const day = i - 2;
    days.push(day > 0 && day <= 31 ? day : null);
  }
  return days;
}

function formatCalendarTime(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Now';

  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

function savedPostToCalendarEntry(post) {
  const dateValue = post.scheduledTime || post.publishedAt || post.createdAt;
  const date = dateValue ? new Date(dateValue) : null;

  if (!date || Number.isNaN(date.getTime())) return null;
  if (date.getFullYear() !== calendarYear || date.getMonth() !== calendarMonthIndex) return null;

  const platformList = Array.isArray(post.platforms) ? post.platforms : [post.platform || 'facebook'];

  return {
    day: date.getDate(),
    id: post.id || post.externalPostId || `${date.getTime()}-${post.content}`,
    platform: platformList[0] || 'facebook',
    status: post.status === 'published' ? 'Published' : post.status || 'Saved',
    time: formatCalendarTime(date),
    title: post.content || 'Published post',
    source: 'mongo'
  };
}

function linePoints(values, width = 640, height = 210) {
  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = max - min || 1;

  return values
    .map((value, index) => {
      const x = (index / (values.length - 1)) * width;
      const y = height - ((value - min) / range) * (height - 26) - 12;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
}

function getInitialScreen() {
  const params = new URLSearchParams(window.location.search);
  const hasProviderRedirect = params.has('facebook') || params.has('google');
  if (hasProviderRedirect) return 'dashboard';

  const hash = window.location.hash.replace('#', '');
  if (['login', 'signup', 'dashboard', 'admin', 'builder', ...Object.keys(policyPages)].includes(hash)) return hash;
  return 'landing';
}

function App() {
  const [screen, setScreen] = useState(getInitialScreen);

  const navigate = (nextScreen) => {
    setScreen(nextScreen);
    window.history.replaceState(null, '', nextScreen === 'landing' ? window.location.pathname : `#${nextScreen}`);
  };

  if (screen === 'dashboard') {
    return <DashboardApp />;
  }

  if (screen === 'admin') {
    return <AdminDashboard openDashboard={() => navigate('dashboard')} openPublicSite={() => navigate('landing')} />;
  }

  if (screen === 'builder') {
    return <WebsiteBuilder openPublicSite={() => navigate('landing')} openDashboard={() => navigate('dashboard')} />;
  }

  if (policyPages[screen]) {
    return <LegalPage page={policyPages[screen]} openPublicSite={() => navigate('landing')} openSignup={() => navigate('signup')} />;
  }

  if (screen === 'login' || screen === 'signup') {
    return (
      <AuthPage
        mode={screen}
        openDashboard={() => navigate('dashboard')}
        openLogin={() => navigate('login')}
        openPublicSite={() => navigate('landing')}
        openSignup={() => navigate('signup')}
      />
    );
  }

  return (
    <LandingPage
      openDashboard={() => navigate('dashboard')}
      openLogin={() => navigate('login')}
      openSignup={() => navigate('signup')}
      openPolicy={(page) => navigate(page)}
      openBuilder={() => navigate('builder')}
    />
  );
}

function DashboardApp() {
  const [activeModule, setActiveModule] = useState('post');
  const [workspaceId, setWorkspaceId] = useState(workspaces[0].id);
  const [message, setMessage] = useState('');
  const [mediaType, setMediaType] = useState('image');
  const [captionMode, setCaptionMode] = useState('manual');
  const [publishMode, setPublishMode] = useState('now');
  const [scheduledAt, setScheduledAt] = useState('');
  const [selectedVideoFile, setSelectedVideoFile] = useState(null);
  const [selectedPlatforms, setSelectedPlatforms] = useState(['facebook', 'instagram']);
  const [previewDevice, setPreviewDevice] = useState('mobile');
  const [notice, setNotice] = useState(getRedirectNotice());
  const [facebookStatus, setFacebookStatus] = useState(null);
  const [instagramStatus, setInstagramStatus] = useState(null);
  const [googleStatus, setGoogleStatus] = useState(null);
  const [, setIsLoadingStatus] = useState(true);
  const [isPosting, setIsPosting] = useState(false);
  const [reportRange, setReportRange] = useState('30D');
  const [reportPlatform, setReportPlatform] = useState('All');
  const [inboxFilter, setInboxFilter] = useState('All');
  const [selectedInboxId, setSelectedInboxId] = useState(1);
  const [bulkRows, setBulkRows] = useState(bulkRowsSeed);
  const [publishedPosts, setPublishedPosts] = useState([]);
  const [publicCalendar, setPublicCalendar] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isWorkspaceMenuOpen, setIsWorkspaceMenuOpen] = useState(false);
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);

  const workspace = workspaces.find((item) => item.id === workspaceId) || workspaces[0];
  const connectedPages = facebookStatus?.pages || [];
  const lastSync = facebookStatus?.lastFacebookSync || null;
  const selectedInbox = inboxItems.find((item) => item.id === selectedInboxId) || inboxItems[0];
  const filteredInbox = inboxItems.filter((item) => inboxFilter === 'All' || item.status === inboxFilter);
  const platformOptions = useMemo(() => platforms.map((platform) => {
    if (platform.id === 'facebook') {
      return {
        ...platform,
        connected: connectedPages.length > 0
      };
    }

    if (platform.id === 'instagram') {
      return {
        ...platform,
        connected: Boolean(instagramStatus?.connected)
      };
    }

    if (platform.id === 'google') {
      return {
        ...platform,
        connected: Boolean(googleStatus?.googleBusiness?.connected)
      };
    }

    if (platform.id === 'youtube') {
      return {
        ...platform,
        connected: Boolean(googleStatus?.youtube?.connected)
      };
    }

    return {
      ...platform,
      connected: false
    };
  }), [connectedPages.length, googleStatus, instagramStatus]);
  const activePlatforms = selectedPlatforms.map((platformId) => platformOptions.find((platform) => platform.id === platformId) || platformById(platformId));
  const previewText = message.trim() || 'Write the next post for this workspace. Live preview updates here.';

  const latestPublishedPost = publishedPosts.find((post) => post.status === 'published') || null;

  const nextPost = useMemo(() => {
    if (latestPublishedPost) {
      const pageName = latestPublishedPost.pageName || 'Facebook';
      return `Last published on ${pageName}`;
    }

    const item = calendarPosts.find((post) => post.day >= 2);
    return item ? `${item.title} on ${platformById(item.platform).label}, July ${item.day} at ${item.time}` : 'No post scheduled yet';
  }, [latestPublishedPost]);

  const loadFacebookStatus = async () => {
    try {
      setIsLoadingStatus(true);
      const response = await axios.get(`${API_BASE}/api/facebook/status`, { withCredentials: true });
      setFacebookStatus(response.data);
    } catch (err) {
      setNotice({ type: 'error', message: `Status check failed: ${err.response?.data?.error || err.message}` });
    } finally {
      setIsLoadingStatus(false);
    }
  };

  const loadInstagramStatus = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/instagram/status`, { withCredentials: true });
      setInstagramStatus(response.data);
    } catch (err) {
      if (err.response?.status !== 401) {
        setNotice({ type: 'error', message: `Instagram status failed: ${err.response?.data?.error || err.message}` });
      }
    }
  };

  const loadGoogleStatus = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/google/status`, { withCredentials: true });
      setGoogleStatus(response.data);
    } catch (err) {
      if (err.response?.status !== 401) {
        setNotice({ type: 'error', message: `Google status failed: ${err.response?.data?.error || err.message}` });
      }
    }
  };

  const loadPublishedPosts = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/posts`, { withCredentials: true });
      setPublishedPosts(response.data.posts || []);
    } catch (err) {
      if (err.response?.status !== 401) {
        setNotice({ type: 'error', message: `Posts load failed: ${err.response?.data?.error || err.message}` });
      }
    }
  };

  const refreshStatuses = async () => {
    await Promise.all([
      loadFacebookStatus(),
      loadInstagramStatus(),
      loadGoogleStatus(),
      loadPublishedPosts()
    ]);
  };

  useEffect(() => {
    refreshStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedPlatforms((current) => {
      const connectedIds = platformOptions
        .filter((platform) => platform.connected)
        .map((platform) => platform.id);
      const filtered = current.filter((platformId) => connectedIds.includes(platformId));

      if (filtered.length) return filtered;
      return connectedIds.length ? [connectedIds[0]] : [];
    });
  }, [platformOptions]);

  const togglePlatform = (platformId) => {
    const platform = platformOptions.find((item) => item.id === platformId);

    if (!platform?.connected) {
      setNotice({ type: 'warning', message: `${platform?.label || 'Profile'} connected nahi hai. Profiles page se connect karo.` });
      setActiveModule('profiles');
      return;
    }

    setSelectedPlatforms((current) => {
      if (current.includes(platformId)) {
        return current.length === 1 ? current : current.filter((item) => item !== platformId);
      }

      return [...current, platformId];
    });
  };

  const connectFacebook = () => {
    window.location.href = `${API_BASE}/auth/facebook`;
  };

  const connectInstagram = () => {
    window.location.href = `${API_BASE}/auth/instagram`;
  };

  const connectGoogle = (service = 'google') => {
    window.location.href = `${API_BASE}/auth/google?service=${service}`;
  };

  const openProfiles = () => {
    setActiveModule('profiles');
  };

  const writeWithAI = () => {
    setCaptionMode('ai');
    setMessage(
      `Fresh update from ${workspace.name}.\n\nWe are ready with a sharper experience, faster response, and better service for every customer. Message us today and our team will guide you personally.\n\n#${workspace.name.replace(/\s/g, '')} #Growth #LocalBusiness`
    );
    setNotice({ type: 'success', message: 'AI caption draft created. Edit it before posting.' });
  };

  const hasScheduleTime = Boolean(scheduledAt);
  const scheduleDate = hasScheduleTime ? new Date(scheduledAt) : null;
  const wantsSchedule = publishMode === 'schedule' || hasScheduleTime;

  const postNow = async () => {
    if (publishMode !== 'now' || hasScheduleTime) {
      await queuePost();
      return;
    }

    if (!message.trim()) {
      setNotice({ type: 'warning', message: 'Post karne se pehle caption likho.' });
      return;
    }

    const wantsYoutube = selectedPlatforms.includes('youtube');
    const wantsFacebook = selectedPlatforms.includes('facebook');

    if (wantsYoutube && !selectedVideoFile) {
      setNotice({ type: 'warning', message: 'YouTube upload ke liye Add video se video file select karo.' });
      return;
    }

    try {
      setIsPosting(true);
      const uploadedTargets = [];

      if (wantsYoutube) {
        setNotice({ type: 'neutral', message: 'Uploading video to YouTube...' });
        const title = message.split('\n').find((line) => line.trim()) || selectedVideoFile.name || 'Easten Social video';
        const youtubeResponse = await axios.post(`${API_BASE}/api/youtube/upload-raw`, selectedVideoFile, {
          withCredentials: true,
          headers: {
            'Content-Type': selectedVideoFile.type || 'video/mp4',
            'x-youtube-title': encodeURIComponent(title),
            'x-youtube-description': encodeURIComponent(message),
            'x-file-name': encodeURIComponent(selectedVideoFile.name),
            'x-privacy-status': 'public'
          }
        });
        uploadedTargets.push(`YouTube video ${youtubeResponse.data.videoId}`);
      }

      let response = null;
      if (wantsFacebook) {
        setNotice({ type: 'neutral', message: wantsYoutube ? 'YouTube done. Publishing Facebook post...' : 'Publishing Facebook post...' });
        response = await axios.post(`${API_BASE}/api/post-to-fb`, {
          mediaType,
          message,
          platforms: activePlatforms.map((item) => item.id),
          scheduledTime: null
        }, { withCredentials: true });
        uploadedTargets.push(`Facebook page ${response.data.pageName}`);
      }

      if (!uploadedTargets.length) {
        setNotice({ type: 'success', message: 'Post prepared for selected platforms. Backend connection next phase mein attach hoga.' });
        return;
      }

      setNotice({
        type: 'success',
        message: `Published: ${uploadedTargets.join(' + ')}. Saved to MongoDB.`
      });
      setMessage('');
      setSelectedVideoFile(null);
      if (response?.data?.post) {
        setPublishedPosts((current) => [response.data.post, ...current]);
      }
      if (wantsFacebook) await loadFacebookStatus();
      await loadPublishedPosts();
    } catch (err) {
      setNotice({ type: 'error', message: `Post failed: ${err.response?.data?.error || err.message}` });
    } finally {
      setIsPosting(false);
    }
  };

  const queuePost = async () => {
    if (!message.trim()) {
      setNotice({ type: 'warning', message: 'Schedule karne ke liye caption likho.' });
      return;
    }

    if (wantsSchedule) {
      if (!scheduledAt) {
        setNotice({ type: 'warning', message: 'Schedule karne ke liye date aur time select karo.' });
        return;
      }

      if (!scheduleDate || Number.isNaN(scheduleDate.getTime())) {
        setNotice({ type: 'warning', message: 'Valid schedule date aur time select karo.' });
        return;
      }

      if (scheduleDate <= new Date(Date.now() + 60000)) {
        setNotice({ type: 'warning', message: 'Schedule time kam se kam 1 minute future mein hona chahiye.' });
        return;
      }

      const wantsYoutube = selectedPlatforms.includes('youtube');
      const wantsFacebook = selectedPlatforms.includes('facebook');

      if (wantsYoutube && !selectedVideoFile) {
        setNotice({ type: 'warning', message: 'YouTube schedule ke liye Add video se video file select karo.' });
        return;
      }

      if (!wantsYoutube && !wantsFacebook) {
        setNotice({ type: 'warning', message: 'Scheduling ke liye YouTube ya Facebook select karo.' });
        return;
      }

      try {
        setIsPosting(true);
        let response = null;

        if (wantsYoutube) {
          const title = message.split('\n').find((line) => line.trim()) || selectedVideoFile.name || 'Easten Social video';
          setNotice({ type: 'neutral', message: 'Scheduling YouTube video...' });
          response = await axios.post(`${API_BASE}/api/youtube/schedule-raw`, selectedVideoFile, {
            withCredentials: true,
            headers: {
              'Content-Type': selectedVideoFile.type || 'video/mp4',
              'x-youtube-title': encodeURIComponent(title),
              'x-youtube-description': encodeURIComponent(message),
              'x-file-name': encodeURIComponent(selectedVideoFile.name),
              'x-scheduled-time': encodeURIComponent(scheduleDate.toISOString())
            }
          });
        } else {
          setNotice({ type: 'neutral', message: 'Scheduling Facebook post...' });
          response = await axios.post(`${API_BASE}/api/schedule-post`, {
            mediaType,
            message,
            platforms: activePlatforms.map((item) => item.id),
            scheduledTime: scheduleDate.toISOString()
          }, { withCredentials: true });
        }

        const acceptedTime = response.data.scheduledTime
          ? new Date(response.data.scheduledTime).toLocaleString()
          : new Date(scheduleDate).toLocaleString();
        const scheduledPlatform = wantsYoutube ? 'YouTube' : response.data.pageName;
        setNotice({ type: 'success', message: `Post ${scheduledPlatform} par ${acceptedTime} ke liye schedule ho gaya. Time par auto publish hoga.` });
        setMessage('');
        if (wantsYoutube) setSelectedVideoFile(null);
        if (response.data.post) {
          setPublishedPosts((current) => [response.data.post, ...current]);
        }
        await loadPublishedPosts();
        return;
      } catch (err) {
        setNotice({ type: 'error', message: `Schedule failed: ${err.response?.data?.error || err.message}` });
        return;
      } finally {
        setIsPosting(false);
      }
    }

    const newRow = {
      id: Date.now(),
      date: scheduledAt ? scheduledAt.slice(0, 10) : '2026-07-12',
      platform: activePlatforms.map((item) => item.label).join(' + '),
      caption: message.slice(0, 42),
      media: mediaType,
      status: publishMode === 'schedule' ? 'Scheduled' : 'Draft'
    };

    setBulkRows((current) => [newRow, ...current]);
    setNotice({ type: 'success', message: 'Draft queue mein save ho gaya.' });
    setMessage('');
  };

  return (
    <div className={cx('mp-app', isSidebarCollapsed && 'sidebar-collapsed')}>
      <aside className={cx('mp-side', isSidebarCollapsed && 'collapsed')}>
        <div className="mp-brand">
          <span>ES</span>
          <div>
            <strong>Easten Social</strong>
          </div>
        </div>

        <section className="workspace-switcher" aria-label="Workspace switcher">
          <p className="side-label">Switch workspace</p>
          <button
            className="workspace-select-wrap workspace-menu-trigger"
            title={workspace.name}
            type="button"
            onClick={() => setIsWorkspaceMenuOpen((value) => !value)}
          >
            <span className="workspace-avatar" style={{ background: workspace.color }}>{workspace.initials}</span>
            <span className="workspace-select">
              <strong>{workspace.name}</strong>
              <small>{workspace.plan}</small>
            </span>
            <em>⌄</em>
          </button>
          {isWorkspaceMenuOpen && (
            <div className="workspace-menu">
              {workspaces.map((item) => (
                <button
                  className={cx(workspaceId === item.id && 'active')}
                  key={item.id}
                  onClick={() => {
                    setWorkspaceId(item.id);
                    setIsWorkspaceMenuOpen(false);
                  }}
                  type="button"
                >
                  <span className="workspace-avatar" style={{ background: item.color }}>{item.initials}</span>
                  <span>
                    <strong>{item.name}</strong>
                    <small>{item.plan}</small>
                  </span>
                </button>
              ))}
            </div>
          )}
        </section>

        <nav className="module-nav" aria-label="Social modules">
          <p className="side-label">Workflow Menu</p>
          {modules.map((item) => (
            <button
              className={cx('module-link', activeModule === item.id && 'active')}
              key={item.id}
              onClick={() => setActiveModule(item.id)}
              title={item.label}
              type="button"
            >
              <i><ModuleIcon id={item.id} /></i>
              <span>{item.label}</span>
              <small>{item.meta}</small>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="support-btn" type="button" onClick={() => setNotice({ type: 'success', message: 'Support center ready. Live chat/helpdesk next backend phase mein attach hoga.' })}>
            <i><ModuleIcon id="support" /></i>
            <span>Support</span>
          </button>
          <div className="account-menu-wrap">
            <button className="support-btn account-trigger" type="button" onClick={() => setIsAccountMenuOpen((value) => !value)}>
              <span className="workspace-avatar" style={{ background: workspace.color }}>{workspace.initials}</span>
              <span>Account</span>
            </button>
            {isAccountMenuOpen && (
              <div className="account-popover">
                <button type="button">Account Details</button>
                <button type="button">Edit Details</button>
                <button type="button" onClick={() => setNotice({ type: 'success', message: 'Logout flow backend auth phase mein attach hoga.' })}>Logout</button>
              </div>
            )}
          </div>
          <button
            className="collapse-btn bottom-collapse"
            type="button"
            onClick={() => setIsSidebarCollapsed((value) => !value)}
            aria-label={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {isSidebarCollapsed ? '›' : '‹'}
          </button>
        </div>
      </aside>

      <main className="mp-main">
        <header className="command-bar">
          <div>
            <h1>{workspace.name} Workflow</h1>
          </div>
          <div className="command-actions">
            <button className="btn primary connect-big" type="button" onClick={openProfiles}>Connect profiles to post</button>
          </div>
        </header>

        {notice && (
          <div className={cx('notice', notice.type)}>
            <span>{notice.message}</span>
            <button type="button" onClick={() => setNotice(null)} aria-label="Dismiss notice">x</button>
          </div>
        )}

        <section className="signal-grid" aria-label="Workspace signals">
          <Metric label="Audience" value={workspace.audience} note="Across profiles" />
          <Metric label="Next Post" value={`${workspace.queue}`} note={nextPost} />
          <Metric label="Inbox" value={workspace.unread} note="Needs response" />
          <Metric label="Ad Spend" value={workspace.adSpend} note="This month" />
        </section>

        {activeModule === 'post' && (
          <PostNow
            activePlatforms={activePlatforms}
            captionMode={captionMode}
            isPosting={isPosting}
            mediaType={mediaType}
            message={message}
            platforms={platformOptions}
            previewDevice={previewDevice}
            previewText={previewText}
            publishMode={publishMode}
            scheduledAt={scheduledAt}
            selectedPlatforms={selectedPlatforms}
            setCaptionMode={setCaptionMode}
            setMediaType={setMediaType}
            setMessage={setMessage}
            setPreviewDevice={setPreviewDevice}
            setPublishMode={setPublishMode}
            setScheduledAt={setScheduledAt}
            selectedVideoFile={selectedVideoFile}
            setSelectedVideoFile={setSelectedVideoFile}
            togglePlatform={togglePlatform}
            postNow={postNow}
            queuePost={queuePost}
            writeWithAI={writeWithAI}
            setNotice={setNotice}
            workspace={workspace}
          />
        )}

        {activeModule === 'manage' && (
          <ManagePosts
            posts={publishedPosts}
            setActiveModule={setActiveModule}
            setNotice={setNotice}
            setPublishedPosts={setPublishedPosts}
          />
        )}

        {activeModule === 'calendar' && (
          <CalendarView
            publicCalendar={publicCalendar}
            publishedPosts={publishedPosts}
            setNotice={setNotice}
            setPublicCalendar={setPublicCalendar}
          />
        )}

        {activeModule === 'messaging' && (
          <Messaging
            filteredInbox={filteredInbox}
            inboxFilter={inboxFilter}
            selectedInbox={selectedInbox}
            selectedInboxId={selectedInboxId}
            setNotice={setNotice}
            setInboxFilter={setInboxFilter}
            setSelectedInboxId={setSelectedInboxId}
          />
        )}

        {activeModule === 'reports' && (
          <Reports
            platformOptions={platformOptions}
            reportPlatform={reportPlatform}
            reportRange={reportRange}
            setNotice={setNotice}
            setReportPlatform={setReportPlatform}
            setReportRange={setReportRange}
          />
        )}

        {activeModule === 'profiles' && (
          <Profiles
            connectedPages={connectedPages}
            connectFacebook={connectFacebook}
            connectGoogle={connectGoogle}
            connectInstagram={connectInstagram}
            facebookStatus={facebookStatus}
            googleStatus={googleStatus}
            instagramStatus={instagramStatus}
            lastSync={lastSync}
            setNotice={setNotice}
          />
        )}

        {activeModule === 'bulk' && (
          <BulkScheduling
            bulkRows={bulkRows}
            setNotice={setNotice}
            setBulkRows={setBulkRows}
            writeWithAI={writeWithAI}
          />
        )}

        {activeModule === 'ads' && <Ads setNotice={setNotice} />}
      </main>
    </div>
  );
}

function LandingPage({ openDashboard, openLogin, openSignup, openPolicy }) {
  const [comparisonTarget, setComparisonTarget] = useState(competitorPlatforms[0]);
  const [activeWorkflowIndex, setActiveWorkflowIndex] = useState(0);
  const [showSignupPrompt, setShowSignupPrompt] = useState(false);
  const activeStep = guidedWorkflowSteps[activeWorkflowIndex] || guidedWorkflowSteps[0];

  useEffect(() => {
    if (window.localStorage.getItem('easten-signup-popup-dismissed') === 'yes') return undefined;
    const timer = window.setTimeout(() => setShowSignupPrompt(true), 10000);
    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      const section = document.getElementById('how-it-works');
      if (!section) return;
      const rect = section.getBoundingClientRect();
      const total = Math.max(section.offsetHeight - window.innerHeight, 1);
      const progress = Math.min(Math.max(-rect.top / total, 0), 0.999);
      setActiveWorkflowIndex(Math.floor(progress * guidedWorkflowSteps.length));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeSignupPrompt = () => {
    window.localStorage.setItem('easten-signup-popup-dismissed', 'yes');
    setShowSignupPrompt(false);
  };

  return (
    <main className="site-shell easten-home">
      <nav className="site-nav easten-nav">
        <button className="site-logo" type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Easten Social home">
          <span>ES</span>
          <strong>eSocial</strong>
        </button>
        <div className="site-links">
          <a href="#top">Home</a>
          <a href="#features">Features</a>
          <a href="#how-it-works">How it works</a>
          <a href="#compare">Compare</a>
          <button className="site-login" type="button" onClick={openLogin}>Login</button>
          <button className="site-cta" type="button" onClick={openSignup}>Register Now</button>
        </div>
      </nav>

      <section className="easten-hero refined-hero" id="top">
        <div className="easten-hero-copy">
          <h1>Automate</h1>
          <h2>at absolutely zero cost.</h2>
          <p>
            India's first free social media management tool built for brands, SMEs, and agencies.
            Plan, post, manage, track, and report from one simple workspace.
          </p>
          <button className="hero-pill-cta" type="button" onClick={openSignup}>
            <span>Get started now</span>
            <i aria-hidden="true">→</i>
          </button>
          <div className="hero-powered">
            <strong>Powered By:</strong>
            <div>
              <img src="/brand/aws.png" alt="AWS" />
              <img src="/brand/meta.png" alt="Meta" />
              <img src="/brand/google.png" alt="Google" />
              <img src="/brand/linkedin.png" alt="LinkedIn" />
            </div>
          </div>
        </div>

        <div className="hero-product-stage refined-visual" aria-label="Easten Social product preview">
          <div className="stage-topbar"><span /><span /><span /><strong>Agency Command Center</strong></div>
          <div className="stage-grid">
            <div className="stage-sidebar">{['Post', 'Manage', 'Calendar', 'Inbox', 'Reports'].map((item) => <b key={item}>{item}</b>)}</div>
            <div className="stage-compose">
              <small>Post Now</small>
              <strong>Compose Everywhere with one click</strong>
              <p>Build one campaign and adapt it for feed, reels, stories, shorts and business updates.</p>
              <div className="brand-dot-row">{['f', 'IG', 'G', 'YT', 'in', 'X'].map((item) => <i key={item}>{item}</i>)}</div>
            </div>
            <div className="stage-preview"><strong>Live preview</strong><span>Instagram</span><p>Launch caption preview with image, video or story-ready layout.</p><b /></div>
            <div className="stage-chart">{[44, 70, 58, 86, 76].map((height) => <span style={{ height: `${height}%` }} key={height} />)}</div>
          </div>
        </div>
      </section>

      <section className="home-section feature-panorama" id="features">
        <div className="section-title">
          <h2>Exclusive Features</h2>
        </div>
        <div className="feature-panorama-grid exclusive-grid">
          {exclusiveFeatures.map(([title, text]) => (
            <article key={title}><span>{title.slice(0, 2)}</span><strong>{title}</strong><p>{text}</p></article>
          ))}
        </div>
      </section>

      <section className="home-section partner-band">
        <div className="section-title">
          <h2>Our Partner</h2>
        </div>
        <div className="partner-row">
          {partnerBrands.map((brand) => <span className={`partner-logo ${brand.toLowerCase().replace(/[^a-z]/g, '')}`} key={brand}>{brand}</span>)}
        </div>
      </section>

      <section className="guided-workflow" id="how-it-works">
        <div className="guided-sticky">
          <div className="workflow-copy">
            <p className="site-eyebrow">How it works</p>
            <h2>Easier than you expect.</h2>
            <p>Inspired by the easiest publishing tools, here is the step-by-step guide to use our platform.</p>
            <div className="workflow-step-card">
              <span>{activeStep.label}</span>
              <strong>{activeStep.title}</strong>
              <p>{activeStep.text}</p>
            </div>
          </div>
          <div className="workflow-screen drop-up-visual" key={activeWorkflowIndex}>
            <div className="workflow-browser">
              <div className="stage-topbar"><span /><span /><span /><strong>{activeStep.visualTitle}</strong></div>
              <div className="workflow-dashboard-shot">
                <aside>{['Login', 'Profile', 'Post', 'Report'].map((item) => <b key={item}>{item}</b>)}</aside>
              <section>
                <small>{activeStep.label}</small>
                <h3>{activeStep.title}</h3>
                <p>{activeStep.text}</p>
                <div>{activeStep.chips.map((card) => <span key={card}>{card}</span>)}</div>
              </section>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-section comparison-lab" id="compare">
        <div>
          <p className="site-eyebrow">Compare before you choose</p>
          <h2>We vs<br />Top Platforms</h2>
          <p>Select any platform and compare the work that matters most for Indian agencies.</p>
          <label className="compare-select"><span>Compare with</span><select value={comparisonTarget} onChange={(event) => setComparisonTarget(event.target.value)}>{competitorPlatforms.map((name) => <option key={name}>{name}</option>)}</select></label>
        </div>
        <div className="comparison-table three-col-compare">
          <div className="comparison-head"><strong>Features</strong><strong>ESocial</strong><strong>{comparisonTarget}</strong></div>
          {eastenAdvantages.map((feature, index) => (
            <div className="comparison-row" key={feature}><span>{feature}</span><span className="tick-mark">✓</span><span>{index < 3 ? '✓' : 'Plan dependent'}</span></div>
          ))}
        </div>
      </section>

      <section className="home-section best-section">
        <div className="section-title">
          <h2>Why We Are the Best</h2>
        </div>
        <div className="best-grid">
          {bestReasons.map(([title, text]) => <article key={title}><strong>{title}</strong><p>{text}</p></article>)}
        </div>
      </section>

      <section className="home-section upcoming-suite">
        <div><p className="site-eyebrow">Upcoming business tools</p><h2>More Easten tools are coming.</h2><p>Social is the first layer. The wider Easten ecosystem can grow into CRM, WhatsApp API, invoicing, HR, payroll and client portals.</p></div>
        <div className="upcoming-grid">{['WhatsApp CRM', 'AI Content Studio', 'Client Portal', 'Invoice Suite', 'HR & Payroll', 'Lead Automation'].map((item) => <span key={item}>{item}</span>)}</div>
      </section>

      <section className="home-section security-band">
        <div><p className="site-eyebrow">Security and scale</p><h2>A serious workspace for serious client data.</h2><p>Easten Social is designed around secure cloud infrastructure, role-based agency workflows, platform authorization, and clean data separation between workspaces.</p></div>
        <div className="security-cards">{['AWS-grade infrastructure approach', 'Workspace-level data separation', 'OAuth based platform access', 'Client approval workflow'].map((item) => <span key={item}>{item}</span>)}</div>
      </section>

      <section className="modern-final home-final">
        <h2>Make your agency look bigger, faster, and more organized.</h2>
        <div><button className="site-cta" type="button" onClick={openSignup}>Register Now</button></div>
      </section>

      <footer className="site-footer easten-footer">
        <div className="footer-main">
          <div className="footer-brand">
            <span className="footer-logo">ES</span>
            <strong>eSocial</strong>
            <div className="follow-row"><b>Follow Us:</b>{['f', 'IG', 'YT', 'in', 'X'].map((item) => <span key={item}>{item}</span>)}</div>
          </div>
          <div className="footer-links">
            <button type="button" onClick={() => openPolicy('privacy')}>Privacy Policies</button>
            <button type="button" onClick={() => openPolicy('data-deletion')}>Data Deletion Policies</button>
            <button type="button" onClick={() => openPolicy('terms')}>Terms & Conditions</button>
            <button type="button" onClick={() => openPolicy('disclaimer')}>Disclaimer</button>
          </div>
          <div className="footer-links right-links">
            <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Home</button>
            <button type="button" onClick={openSignup}>Register Now</button>
            <button type="button" onClick={() => openPolicy('about')}>About Us</button>
            <button type="button" onClick={() => openPolicy('contact')}>Contact Us</button>
          </div>
        </div>
        <div className="footer-bottom">eSocial © 2026, All Rights Reserved. A product by <a href="https://www.eastenmediatech.com" target="_blank" rel="noreferrer">Easten Mediatech</a>.</div>
      </footer>

      {showSignupPrompt && (
        <div className="signup-popup" role="dialog" aria-label="Create Easten Social account">
          <button type="button" aria-label="Close signup popup" onClick={closeSignupPrompt}>x</button>
          <strong>Start your free 5-channel workspace</strong>
          <p>Build your first campaign, connect profiles, and see how Easten Social can organize your agency workflow.</p>
          <input placeholder="Work email" type="email" />
          <button className="site-cta" type="button" onClick={openSignup}>Register Now</button>
        </div>
      )}
    </main>
  );
}

function LegalPage({ page, openPublicSite, openSignup }) {
  return (
    <main className="legal-shell">
      <nav className="site-nav easten-nav legal-nav">
        <button className="site-logo" type="button" onClick={openPublicSite}><span>ES</span><strong>Easten Social</strong></button>
        <div className="site-links"><button className="site-login" type="button" onClick={openPublicSite}>Home</button><button className="site-cta" type="button" onClick={openSignup}>Get Started Now</button></div>
      </nav>
      <section className="legal-card">
        <p className="site-eyebrow">{page.eyebrow}</p>
        <h1>{page.title}</h1>
        {page.body.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
      </section>
    </main>
  );
}

function WebsiteBuilder({ openPublicSite, openDashboard }) {
  const [sections, setSections] = useState(() => {
    try {
      const saved = window.localStorage.getItem(builderStorageKey);
      return saved ? JSON.parse(saved) : defaultBuilderSections;
    } catch (error) {
      return defaultBuilderSections;
    }
  });
  const [selectedId, setSelectedId] = useState(sections[0]?.id || '');
  const [draggedId, setDraggedId] = useState(null);
  const selectedSection = sections.find((section) => section.id === selectedId) || sections[0];

  useEffect(() => {
    window.localStorage.setItem(builderStorageKey, JSON.stringify(sections));
  }, [sections]);

  const selectSection = (id) => setSelectedId(id);
  const updateSelected = (patch) => {
    setSections((current) => current.map((section) => (section.id === selectedSection.id ? { ...section, ...patch } : section)));
  };
  const updateCard = (index, patch) => {
    updateSelected({
      cards: selectedSection.cards.map((card, cardIndex) => (cardIndex === index ? { ...card, ...patch } : card))
    });
  };
  const updateRow = (index, patch) => {
    updateSelected({
      rows: selectedSection.rows.map((row, rowIndex) => (rowIndex === index ? { ...row, ...patch } : row))
    });
  };
  const addSection = (type) => {
    const section = createBuilderSection(type);
    setSections((current) => [...current, section]);
    setSelectedId(section.id);
  };
  const duplicateSection = (id) => {
    const original = sections.find((section) => section.id === id);
    if (!original) return;
    const copy = { ...original, id: makeBuilderId(original.type), title: `${original.title} copy` };
    setSections((current) => {
      const index = current.findIndex((section) => section.id === id);
      const next = [...current];
      next.splice(index + 1, 0, copy);
      return next;
    });
    setSelectedId(copy.id);
  };
  const deleteSection = (id) => {
    if (sections.length === 1) return;
    setSections((current) => current.filter((section) => section.id !== id));
    if (selectedId === id) setSelectedId(sections.find((section) => section.id !== id)?.id || '');
  };
  const onDropSection = (targetId) => {
    if (!draggedId || draggedId === targetId) return;
    setSections((current) => {
      const dragged = current.find((section) => section.id === draggedId);
      if (!dragged) return current;
      const withoutDragged = current.filter((section) => section.id !== draggedId);
      const targetIndex = withoutDragged.findIndex((section) => section.id === targetId);
      const next = [...withoutDragged];
      next.splice(targetIndex, 0, dragged);
      return next;
    });
    setDraggedId(null);
  };
  const resetBuilder = () => {
    const freshSections = defaultBuilderSections.map((section) => ({ ...section, id: makeBuilderId(section.type) }));
    setSections(freshSections);
    setSelectedId(freshSections[0]?.id || '');
  };

  return (
    <main className="builder-shell">
      <header className="builder-top">
        <button className="site-logo" type="button" onClick={openPublicSite}><span>ES</span><strong>Website Builder</strong></button>
        <div>
          <button className="site-login" type="button" onClick={openPublicSite}>View Homepage</button>
          <button className="site-login" type="button" onClick={openDashboard}>Dashboard</button>
          <button className="site-cta" type="button" onClick={() => window.localStorage.setItem(builderStorageKey, JSON.stringify(sections))}>Save Design</button>
        </div>
      </header>

      <section className="builder-grid">
        <aside className="builder-palette">
          <strong>Add blocks</strong>
          {builderPalette.map((item) => (
            <button type="button" key={item.type} onClick={() => addSection(item.type)}>+ {item.label}</button>
          ))}
          <button className="builder-reset" type="button" onClick={resetBuilder}>Reset demo layout</button>
          <small>Drag sections in the middle preview. Select any section to edit text, cards, tables, images and graphics.</small>
        </aside>

        <section className="builder-preview">
          {sections.map((section, index) => (
            <article
              className={cx('builder-section-card', selectedId === section.id && 'selected')}
              draggable
              key={section.id}
              onClick={() => selectSection(section.id)}
              onDragStart={() => setDraggedId(section.id)}
              onDragOver={(event) => event.preventDefault()}
              onDrop={() => onDropSection(section.id)}
            >
              <div className="builder-section-tools">
                <span>Drag {index + 1}</span>
                <button type="button" onClick={(event) => { event.stopPropagation(); duplicateSection(section.id); }}>Duplicate</button>
                <button type="button" onClick={(event) => { event.stopPropagation(); deleteSection(section.id); }}>Delete</button>
              </div>
              <BuilderPreviewSection section={section} />
            </article>
          ))}
        </section>

        <aside className="builder-editor">
          {selectedSection && (
            <BuilderEditor
              section={selectedSection}
              updateSelected={updateSelected}
              updateCard={updateCard}
              updateRow={updateRow}
            />
          )}
        </aside>
      </section>
    </main>
  );
}

function BuilderPreviewSection({ section }) {
  if (section.type === 'hero') {
    return (
      <div className="builder-hero-preview">
        <p className="site-eyebrow">{section.kicker}</p>
        <h1>{section.title}</h1>
        <h2>{section.subtitle}</h2>
        <p>{section.body}</p>
        <div><button type="button">{section.buttonText}</button><button type="button">{section.secondaryButtonText}</button></div>
      </div>
    );
  }

  if (section.type === 'table') {
    return (
      <div className="builder-table-preview">
        <p className="site-eyebrow">{section.kicker}</p>
        <h2>{section.title}</h2>
        <p>{section.body}</p>
        <table>
          <tbody>
            {section.rows.map((row) => (
              <tr key={`${row.feature}-${row.easten}`}><td>{row.feature}</td><td>{row.easten}</td><td>{row.other}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  if (section.type === 'image') {
    return (
      <div className="builder-image-preview">
        <div>
          <p className="site-eyebrow">{section.kicker}</p>
          <h2>{section.title}</h2>
          <p>{section.body}</p>
          <small>{section.caption}</small>
        </div>
        {section.imageUrl ? <img src={section.imageUrl} alt={section.caption || section.title} /> : <div className="builder-image-placeholder">Image / video visual</div>}
      </div>
    );
  }

  if (section.type === 'text') {
    return (
      <div className="builder-text-preview">
        <p className="site-eyebrow">{section.kicker}</p>
        <h2>{section.title}</h2>
        <p>{section.body}</p>
      </div>
    );
  }

  return (
    <div className="builder-cards-preview">
      <p className="site-eyebrow">{section.kicker}</p>
      <h2>{section.title}</h2>
      <p>{section.body}</p>
      <div>
        {(section.cards || []).map((card) => <article key={`${card.title}-${card.text}`}><strong>{card.title}</strong><span>{card.text}</span></article>)}
      </div>
    </div>
  );
}

function BuilderEditor({ section, updateSelected, updateCard, updateRow }) {
  const onImageFile = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => updateSelected({ imageUrl: reader.result });
    reader.readAsDataURL(file);
  };

  return (
    <div>
      <h2>Edit {section.type}</h2>
      <BuilderInput label="Small label" value={section.kicker || ''} onChange={(value) => updateSelected({ kicker: value })} />
      <BuilderInput label="Heading" value={section.title || ''} onChange={(value) => updateSelected({ title: value })} />
      {section.type === 'hero' && <BuilderInput label="Subheading" value={section.subtitle || ''} onChange={(value) => updateSelected({ subtitle: value })} />}
      <BuilderTextarea label="Body text" value={section.body || ''} onChange={(value) => updateSelected({ body: value })} />
      {section.type === 'hero' && (
        <>
          <BuilderInput label="Main button" value={section.buttonText || ''} onChange={(value) => updateSelected({ buttonText: value })} />
          <BuilderInput label="Second button" value={section.secondaryButtonText || ''} onChange={(value) => updateSelected({ secondaryButtonText: value })} />
        </>
      )}
      {section.type === 'image' && (
        <>
          <BuilderInput label="Image or video URL" value={section.imageUrl || ''} onChange={(value) => updateSelected({ imageUrl: value })} />
          <label className="builder-field"><span>Upload image</span><input type="file" accept="image/*" onChange={onImageFile} /></label>
          <BuilderInput label="Caption" value={section.caption || ''} onChange={(value) => updateSelected({ caption: value })} />
          <button type="button" onClick={() => updateSelected({ imageUrl: '' })}>Remove image</button>
        </>
      )}
      {section.cards && (
        <div className="builder-edit-list">
          <strong>Cards / graphics</strong>
          {section.cards.map((card, index) => (
            <div className="builder-edit-item" key={`${card.title}-${index}`}>
              <BuilderInput label="Title" value={card.title} onChange={(value) => updateCard(index, { title: value })} />
              <BuilderTextarea label="Text" value={card.text} onChange={(value) => updateCard(index, { text: value })} />
              <button type="button" onClick={() => updateSelected({ cards: section.cards.filter((_, cardIndex) => cardIndex !== index) })}>Remove card</button>
            </div>
          ))}
          <button type="button" onClick={() => updateSelected({ cards: [...section.cards, { title: 'New card', text: 'Edit this card text.' }] })}>Add card</button>
        </div>
      )}
      {section.rows && (
        <div className="builder-edit-list">
          <strong>Table rows</strong>
          {section.rows.map((row, index) => (
            <div className="builder-edit-item" key={`${row.feature}-${index}`}>
              <BuilderInput label="Feature" value={row.feature} onChange={(value) => updateRow(index, { feature: value })} />
              <BuilderInput label="Easten Social" value={row.easten} onChange={(value) => updateRow(index, { easten: value })} />
              <BuilderInput label="Other platform" value={row.other} onChange={(value) => updateRow(index, { other: value })} />
              <button type="button" onClick={() => updateSelected({ rows: section.rows.filter((_, rowIndex) => rowIndex !== index) })}>Remove row</button>
            </div>
          ))}
          <button type="button" onClick={() => updateSelected({ rows: [...section.rows, { feature: 'New feature', easten: 'Included', other: 'Compare' }] })}>Add row</button>
        </div>
      )}
    </div>
  );
}

function BuilderInput({ label, value, onChange }) {
  return (
    <label className="builder-field">
      <span>{label}</span>
      <input value={value} onChange={(event) => onChange(event.target.value)} />
    </label>
  );
}

function BuilderTextarea({ label, value, onChange }) {
  return (
    <label className="builder-field">
      <span>{label}</span>
      <textarea value={value} onChange={(event) => onChange(event.target.value)} />
    </label>
  );
}

function AuthPage({ mode, openDashboard, openLogin, openPublicSite, openSignup }) {
  const isSignup = mode === 'signup';

  return (
    <main className="auth-shell">
      <button className="site-logo auth-logo" type="button" onClick={openPublicSite}>
        <span>ES</span>
        <strong>Easten Social</strong>
      </button>
      <section className="auth-card">
        <p className="site-eyebrow">{isSignup ? 'Create account' : 'Welcome back'}</p>
        <h1>{isSignup ? 'Start your agency workspace' : 'Log in to Easten Social'}</h1>
        <label>
          <span>Email</span>
          <input placeholder="you@company.com" type="email" />
        </label>
        <label>
          <span>Password</span>
          <input placeholder="Enter password" type="password" />
        </label>
        {isSignup && (
          <label>
            <span>Company name</span>
            <input placeholder="Agency or brand name" />
          </label>
        )}
        <button className="site-cta full-width" type="button" onClick={openDashboard}>
          {isSignup ? 'Create workspace' : 'Log in'}
        </button>
        <button className="site-login full-width" type="button" onClick={isSignup ? openLogin : openSignup}>
          {isSignup ? 'Already have an account?' : 'New here? Sign up'}
        </button>
      </section>
    </main>
  );
}

function AdminDashboard({ openDashboard, openPublicSite }) {
  return (
    <main className="admin-shell">
      <nav className="site-nav admin-nav">
        <button className="site-logo" type="button" onClick={openPublicSite}>
          <span>ES</span>
          <strong>Easten Social Admin</strong>
        </button>
        <div className="site-links">
          <button className="site-login" type="button" onClick={openPublicSite}>Home</button>
          <button className="site-cta" type="button" onClick={openDashboard}>User dashboard</button>
        </div>
      </nav>

      <section className="admin-hero">
        <p className="site-eyebrow">Admin dashboard</p>
        <h1>Agency control center</h1>
        <p>Manage subscriptions, workspaces, connected channels, billing status, and platform health.</p>
      </section>

      <section className="admin-stats">
        {adminStats.map((item) => (
          <div className="admin-stat" key={item.label}>
            <span>{item.label}</span>
            <strong>{item.value}</strong>
            <small>{item.note}</small>
          </div>
        ))}
      </section>

      <section className="admin-grid">
        <div className="admin-panel">
          <h2>Recent accounts</h2>
          {['Easten Mediatech', 'Easten Pariwaar', 'Studio North'].map((name, index) => (
            <div className="admin-row" key={name}>
              <strong>{name}</strong>
              <span>{pricingPlans[index]?.name || 'Easten Social Basic'}</span>
              <em>{index === 0 ? 'Active' : 'Trial'}</em>
            </div>
          ))}
        </div>
        <div className="admin-panel">
          <h2>Platform health</h2>
          {['Backend live', 'MongoDB synced', 'YouTube ready', 'Google Business approval pending'].map((item, index) => (
            <div className="admin-row" key={item}>
              <strong>{item}</strong>
              <span>{index === 3 ? 'Waiting on Google' : 'Operational'}</span>
              <em>{index === 3 ? 'Pending' : 'OK'}</em>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

function Metric({ label, value, note }) {
  return (
    <div className="metric">
      <span>{label}</span>
      <strong>{value}</strong>
      <small>{note}</small>
    </div>
  );
}

function ModuleIcon({ id }) {
  const common = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
  const icons = {
    post: <path {...common} d="M4 17l4 3 12-14M4 7h8M4 12h6" />,
    manage: <path {...common} d="M5 5h14v14H5zM8 9h8M8 13h5" />,
    calendar: <path {...common} d="M7 3v4M17 3v4M4 9h16M5 5h14v15H5z" />,
    messaging: <path {...common} d="M4 5h16v11H8l-4 4zM8 9h8M8 13h5" />,
    reports: <path {...common} d="M5 19V9M10 19V5M15 19v-7M20 19H3" />,
    profiles: <path {...common} d="M8 10a4 4 0 118 0M4 20a8 8 0 0116 0" />,
    bulk: <path {...common} d="M6 4h9l3 3v13H6zM14 4v4h4M9 12h6M9 16h6" />,
    ads: <path {...common} d="M4 12h4l9-5v10l-9-5H4zM8 12v5" />,
    support: <path {...common} d="M12 20a8 8 0 100-16 8 8 0 000 16zM9.5 9a2.5 2.5 0 015 0c0 2-2.5 2-2.5 4M12 16h.01" />
  };
  return <svg viewBox="0 0 24 24" aria-hidden="true">{icons[id] || icons.post}</svg>;
}

function PostNow(props) {
  const {
    activePlatforms,
    captionMode,
    isPosting,
    mediaType,
    message,
    platforms: allPlatforms,
    previewDevice,
    previewText,
    publishMode,
    scheduledAt,
    selectedVideoFile,
    selectedPlatforms,
    setCaptionMode,
    setMediaType,
    setMessage,
    setPreviewDevice,
    setPublishMode,
    setScheduledAt,
    setSelectedVideoFile,
    togglePlatform,
    postNow,
    queuePost,
    writeWithAI,
    setNotice,
    workspace
  } = props;
  const primaryActionLabel = scheduledAt
    ? 'Schedule post'
    : publishMode === 'schedule'
      ? 'Schedule post'
      : publishMode === 'draft'
        ? 'Save draft'
        : 'Post now';
  const appendToCaption = (text) => {
    setMessage((current) => `${current}${current.trim() ? '\n\n' : ''}${text}`);
  };
  const attachMedia = (type) => {
    setMediaType(type);
    setNotice({ type: 'success', message: `${type === 'image' ? 'Image' : 'Video'} slot ready. Real upload storage next media phase mein attach hoga.` });
  };
  const selectVideoFile = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setMediaType('video');
    setSelectedVideoFile(file);
    setNotice({ type: 'success', message: `Video selected: ${file.name}. YouTube upload ready.` });
  };
  const addHashtags = () => {
    appendToCaption(`#${workspace.name.replace(/\s/g, '')} #EastenSocial #Growth #LocalBusiness`);
    setNotice({ type: 'success', message: 'Hashtags caption mein add ho gaye.' });
  };
  const openLibrary = () => {
    setNotice({ type: 'success', message: 'Media library ready. Abhi sample/local media slot active hai; cloud storage next phase mein attach hoga.' });
  };

  return (
    <section className="two-column">
      <div className="glass-panel composer">
        <PanelTitle label="Post Now" title="Compose Everywhere with one click" action="Manual + AI caption" />

        <div className="destination-grid">
          {allPlatforms.map((platform) => (
            <button
              className={cx(
                'destination',
                selectedPlatforms.includes(platform.id) && platform.connected && 'selected',
                !platform.connected && 'disconnected'
              )}
              key={platform.id}
              onClick={() => togglePlatform(platform.id)}
              style={{ '--platform': platform.color }}
              aria-label={`${platform.label} ${platform.connected ? 'ready' : 'connect needed'}`}
              title={platform.label}
              disabled={!platform.connected}
              type="button"
            >
              <span>{platform.mark}</span>
              <b aria-hidden="true" />
            </button>
          ))}
        </div>

        <div className="control-grid">
          <Segmented
            label="Media"
            value={mediaType}
            onChange={setMediaType}
            options={[
              { value: 'image', label: 'Image' },
              { value: 'video', label: 'Video' },
              { value: 'reel', label: 'Reel' },
              { value: 'short', label: 'Short' },
              { value: 'story', label: 'Story' }
            ]}
          />
          <Segmented
            label="Caption"
            value={captionMode}
            onChange={(value) => {
              setCaptionMode(value);
              if (value === 'ai') writeWithAI();
            }}
            options={[
              { value: 'manual', label: 'Manual' },
              { value: 'ai', label: 'Write with AI' }
            ]}
          />
          <Segmented
            label="Action"
            value={publishMode}
            onChange={setPublishMode}
            options={['now', 'schedule', 'draft']}
          />
        </div>

        <label className="caption-box">
          <span>Caption</span>
          <textarea
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            placeholder="Craft a post, announcement, offer, reel caption, or Google update..."
          />
        </label>

        <div className="composer-toolbar">
          <button className="tool-btn" type="button" onClick={() => attachMedia('image')}>Add image</button>
          <label className="tool-btn file-tool">
            Add video
            <input type="file" accept="video/*" onChange={selectVideoFile} />
          </label>
          <button className="tool-btn" type="button" onClick={addHashtags}>Hashtags</button>
          <label className="toolbar-schedule">
            <span>Schedule time</span>
            <input
              type="datetime-local"
              value={scheduledAt}
              onChange={(event) => setScheduledAt(event.target.value)}
            />
          </label>
          <span className="char-count">{message.length} / 2200</span>
        </div>

        {selectedVideoFile && (
          <div className="selected-media-line">Selected video: {selectedVideoFile.name}</div>
        )}

        <div className="publish-row compact-publish-row">
          <button className="tool-btn" type="button" onClick={openLibrary}>Open Media Library</button>
          <div className="publish-actions">
            <button className="btn success" type="button" onClick={postNow} disabled={isPosting}>
              {isPosting ? 'Saving...' : primaryActionLabel}
            </button>
            <button className="btn subtle" type="button" onClick={queuePost} disabled={isPosting}>Schedule / Save</button>
          </div>
        </div>
      </div>

      <aside className="preview-stack">
        <div className="glass-panel multi-preview-panel">
          <div className="panel-head compact-head">
            <div>
              <p className="kicker">All platform live preview</p>
              <h2>{previewDevice === 'mobile' ? 'Mobile previews' : 'Desktop previews'}</h2>
            </div>
            <div className="toggle-pair">
              <button className={cx(previewDevice === 'mobile' && 'active')} onClick={() => setPreviewDevice('mobile')} type="button">Mobile</button>
              <button className={cx(previewDevice === 'desktop' && 'active')} onClick={() => setPreviewDevice('desktop')} type="button">Desktop</button>
            </div>
          </div>

          <div className="platform-preview-list">
            {(activePlatforms.length ? activePlatforms : allPlatforms.filter((platform) => platform.connected)).map((platform) => (
              <PlatformLivePreview
                key={platform.id}
                mediaType={mediaType}
                platform={platform}
                previewDevice={previewDevice}
                previewText={previewText}
                workspace={workspace}
              />
            ))}

            {!activePlatforms.length && (
              <div className="empty-box compact-empty">
                <strong>No platform selected</strong>
                <small>Profiles connect karo, phir yahan har platform ka preview dikhega.</small>
              </div>
            )}
          </div>
        </div>
      </aside>
    </section>
  );
}

function PlatformLivePreview({ mediaType, platform, previewDevice, previewText, workspace }) {
  const surfaceMap = {
    instagram: mediaType === 'reel' ? 'Instagram Reel' : 'Instagram feed',
    facebook: 'Facebook feed',
    youtube: mediaType === 'short' ? 'YouTube Short' : 'YouTube video',
    google: 'Google Business update',
    linkedin: 'LinkedIn post'
  };

  return (
    <article className="platform-live-card" style={{ '--platform': platform.color }}>
      <div className="platform-live-head">
        <span>{platform.mark}</span>
        <div>
          <strong>{platform.label}</strong>
          <small>{surfaceMap[platform.id] || 'Social post'} - {previewDevice}</small>
        </div>
        <em>{platform.connected ? 'Ready' : 'Connect'}</em>
      </div>

      <div className={cx('phone-preview compact-phone', previewDevice)}>
        <div className="phone-top" />
        <div className="social-post">
          <div className="post-profile">
            <span style={{ background: workspace.color }}>{workspace.initials}</span>
            <div>
              <strong>{workspace.name}</strong>
              <small>{platform.label}</small>
            </div>
          </div>
          <p>{previewText}</p>
          <div className="media-preview">{mediaType} preview</div>
          <div className="post-actions">
            <span>{platform.id === 'youtube' ? 'Like' : 'Like'}</span>
            <span>{platform.id === 'google' ? 'Call' : 'Comment'}</span>
            <span>{platform.id === 'youtube' ? 'Subscribe' : 'Share'}</span>
          </div>
        </div>
      </div>
    </article>
  );
}

function ManagePosts({ posts = [], setActiveModule, setNotice, setPublishedPosts }) {
  const [editingId, setEditingId] = useState(null);
  const [draft, setDraft] = useState('');
  const [deletedPosts, setDeletedPosts] = useState([]);
  const seedPosts = posts.length ? posts : [
    {
      id: 'demo-published',
      pageName: 'Easten Mediatech',
      content: 'Published campaign preview for Facebook and YouTube.',
      platforms: ['facebook', 'youtube'],
      status: 'published',
      publishedAt: new Date().toISOString()
    },
    {
      id: 'demo-scheduled',
      pageName: 'Easten Mediatech',
      content: 'New branding reveal on Facebook, Instagram and YouTube.',
      platforms: ['facebook', 'instagram', 'youtube'],
      status: 'scheduled',
      scheduledTime: '2026-07-12T10:00:00.000Z'
    },
    {
      id: 'demo-draft',
      pageName: 'Easten Mediatech',
      content: 'Client approval pending for Google Business weekend offer.',
      platforms: ['google'],
      status: 'draft',
      createdAt: new Date().toISOString()
    }
  ];
  const publishedOnly = seedPosts.filter((post) => String(post.status || '').toLowerCase() === 'published');
  const draftOnly = seedPosts.filter((post) => ['draft', 'scheduled', 'queued'].includes(String(post.status || '').toLowerCase()));

  const startEdit = (post) => {
    setEditingId(post.id || post.externalPostId);
    setDraft(post.content || post.message || '');
  };
  const saveEdit = (post) => {
    const key = post.id || post.externalPostId;
    setPublishedPosts((current) => current.map((item) => (
      (item.id || item.externalPostId) === key ? { ...item, content: draft } : item
    )));
    setEditingId(null);
    setNotice({ type: 'success', message: 'Post updated locally. Backend update endpoint next phase mein attach hoga.' });
  };
  const deletePost = (post) => {
    const key = post.id || post.externalPostId;
    setDeletedPosts((current) => [post, ...current].slice(0, 5));
    setPublishedPosts((current) => current.filter((item) => (item.id || item.externalPostId) !== key));
    setNotice({ type: 'success', message: 'Post removed from current workspace view.' });
  };

  return (
    <section className="manage-posts-layout">
      <div className="glass-panel manage-posts-main">
        <div className="manage-posts-head">
          <PanelTitle label="Manage Posts" title="Published posts" action={`${publishedOnly.length} live`} />
          <button className="btn primary" type="button" onClick={() => setActiveModule('post')}>Create new post</button>
        </div>

        <div className="managed-post-list published-grid">
          {publishedOnly.map((post) => {
            const key = post.id || post.externalPostId;
            const postPlatforms = Array.isArray(post.platforms) ? post.platforms : [post.platform || 'facebook'];
            const isEditing = editingId === key;
            return (
              <article className="managed-post-card" key={key}>
                <div className="managed-post-top">
                  <div>
                    <strong>{post.pageName || 'Easten Workspace'}</strong>
                    <small>
                      {post.scheduledTime
                        ? `Scheduled ${new Date(post.scheduledTime).toLocaleString()}`
                        : post.publishedAt
                          ? `Published ${new Date(post.publishedAt).toLocaleString()}`
                          : 'Draft / queued'}
                    </small>
                  </div>
                  <span className={cx('status-chip', post.status)}>{post.status || 'saved'}</span>
                </div>

                <div className="managed-platforms">
                  {postPlatforms.map((platformId) => {
                    const platform = platformById(platformId);
                    return <span style={{ '--platform': platform.color }} key={platformId}>{platform.mark}</span>;
                  })}
                </div>

                {isEditing ? (
                  <textarea className="managed-edit-box" value={draft} onChange={(event) => setDraft(event.target.value)} />
                ) : (
                  <p>{post.content || post.message || 'Saved post content will appear here.'}</p>
                )}

                {post.externalPostId && <small className="post-id-line">Post ID: {post.externalPostId}</small>}

                <div className="managed-actions">
                  {isEditing ? (
                    <>
                      <button className="btn success" type="button" onClick={() => saveEdit(post)}>Save change</button>
                      <button className="btn subtle" type="button" onClick={() => setEditingId(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button className="btn subtle" type="button" onClick={() => startEdit(post)}>Edit</button>
                      <button className="btn subtle" type="button" onClick={() => setNotice({ type: 'success', message: 'Duplicate draft created in queue.' })}>Duplicate</button>
                      <button className="btn danger" type="button" onClick={() => deletePost(post)}>Delete</button>
                    </>
                  )}
                </div>
              </article>
            );
          })}
          {!publishedOnly.length && (
            <div className="empty-box compact-empty">
              <strong>No published posts yet</strong>
              <small>Published posts yahan grid view mein dikhenge.</small>
            </div>
          )}
        </div>
      </div>

      <aside className="manage-side">
        <div className="glass-panel">
          <PanelTitle label="Drafts" title="Draft / scheduled posts" action={`${draftOnly.length}`} />
          {draftOnly.length ? draftOnly.map((post) => (
            <div className="rule-card active" key={post.id || post.externalPostId}>
              <strong>{post.content || post.message}</strong>
              <small>{post.scheduledTime ? new Date(post.scheduledTime).toLocaleString() : 'Draft saved'}</small>
            </div>
          )) : <div className="empty-box compact-empty"><strong>No drafts</strong><small>Drafts and scheduled posts will show here.</small></div>}
        </div>

        <div className="glass-panel">
          <PanelTitle label="Deleted" title="Recent deleted posts" action={`${deletedPosts.length}/5`} />
          {deletedPosts.length ? deletedPosts.map((post) => (
            <div className="rule-card deleted-card" key={post.id || post.externalPostId}>
              <strong>{post.content || post.message}</strong>
              <small>Removed from current view</small>
            </div>
          )) : <div className="empty-box compact-empty"><strong>No deleted posts</strong><small>Last 5 deleted posts yahan dikhenge.</small></div>}
        </div>
      </aside>
    </section>
  );
}

function CalendarView({ publicCalendar, publishedPosts = [], setNotice, setPublicCalendar }) {
  const [movedDays, setMovedDays] = useState({});
  const [selectedCalendarPost, setSelectedCalendarPost] = useState(null);
  const calendarEntries = useMemo(() => {
    const savedEntries = publishedPosts.map(savedPostToCalendarEntry).filter(Boolean);
    return [...savedEntries, ...calendarPosts].map((post) => ({
      ...post,
      day: movedDays[post.id || post.title] || post.day
    }));
  }, [movedDays, publishedPosts]);
  const reviewComments = [
    { status: 'Change', text: 'Instagram caption shorter rakho.' },
    { status: 'Approved', text: 'Google offer post approved by client.' },
    { status: 'Declined', text: 'YouTube short thumbnail update required.' }
  ];
  const shareCalendar = async () => {
    const nextState = !publicCalendar;
    setPublicCalendar(nextState);

    try {
      if (nextState && navigator.clipboard) {
        await navigator.clipboard.writeText(`${window.location.origin}/#calendar-public`);
      }

      setNotice({
        type: 'success',
        message: nextState ? 'Read-only calendar link active and copied.' : 'Public calendar link disabled.'
      });
    } catch (error) {
      setNotice({
        type: 'warning',
        message: 'Read-only calendar link active. Browser ne clipboard copy block kar diya.'
      });
    }
  };
  const moveCalendarPost = (post, targetDay) => {
    if (!post || !targetDay) return;
    setMovedDays((current) => ({ ...current, [post.id || post.title]: targetDay }));
    setNotice({ type: 'success', message: `${post.title} moved to July ${targetDay}. Backend reschedule endpoint next phase mein attach hoga.` });
  };

  return (
    <section className="calendar-workspace">
      <div className="glass-panel calendar-module">
        <div className="calendar-top">
          <div>
            <p className="kicker">Calendar</p>
            <h2>{calendarLabel}</h2>
          </div>
          <div className="calendar-actions">
            <button className="btn subtle" type="button" onClick={() => setNotice({ type: 'success', message: 'Today highlighted. Live calendar is using saved Mongo posts plus planned items.' })}>Today</button>
          </div>
        </div>

        <div className="calendar-filters">
          <span>Month</span>
          <span>Week</span>
          <span>Approval</span>
          <span>Platform</span>
          <span>Client view</span>
        </div>

        <div className="calendar-grid">
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
            <strong className="weekday" key={day}>{day}</strong>
          ))}
          {monthDays().map((day, index) => {
            const posts = calendarEntries.filter((post) => post.day === day);
            return (
              <div
                className={cx('day-cell', day === 1 && 'today')}
                key={`${day || 'blank'}-${index}`}
                onDragOver={(event) => event.preventDefault()}
                onDrop={(event) => {
                  const postKey = event.dataTransfer.getData('text/plain');
                  const movingPost = calendarEntries.find((post) => String(post.id || post.title) === postKey);
                  moveCalendarPost(movingPost, day);
                }}
              >
                {day && <span className="day-number">{day}</span>}
                {posts.map((post) => {
                  const platform = platformById(post.platform);
                  const reviewClass = post.status === 'Ready' ? 'approved' : post.status === 'Needs media' ? 'declined' : 'change';
                  return (
                    <button
                      className={cx('cal-post', post.source === 'mongo' && 'mongo-post', reviewClass)}
                      draggable
                      key={`${post.day}-${post.id || post.title}`}
                      onClick={() => setSelectedCalendarPost(post)}
                      onDragStart={(event) => event.dataTransfer.setData('text/plain', String(post.id || post.title))}
                      style={{ '--platform': platform.color }}
                      type="button"
                    >
                      <small><b>{platform.mark}</b> {post.time}</small>
                      <strong>{post.title}</strong>
                      <span>{post.status === 'Ready' ? 'Approved' : post.status === 'Needs media' ? 'Declined' : 'Changes'}</span>
                    </button>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>

      <aside className="calendar-side">
        <div className="glass-panel">
          <PanelTitle label="Client calendar" title="Share approval link" action={publicCalendar ? 'Live' : 'Off'} />
          <button
            className={cx('btn full', publicCalendar ? 'success' : 'primary')}
            type="button"
            onClick={shareCalendar}
          >
            {publicCalendar ? 'Copy public link again' : 'Create share link'}
          </button>
          <p className="side-note">Client yahan approve, decline, ya change comments de payega.</p>
        </div>

        <div className="glass-panel">
          <PanelTitle label="Review comments" title="Client changes" action={`${reviewComments.length}`} />
          {reviewComments.map((item) => (
            <div className={cx('review-comment', item.status.toLowerCase())} key={item.text}>
              <strong>{item.status}</strong>
              <small>{item.text}</small>
            </div>
          ))}
        </div>

        <div className="glass-panel">
          <PanelTitle label="Selected post" title={selectedCalendarPost ? selectedCalendarPost.title : 'No post selected'} action="Actions" />
          {selectedCalendarPost ? (
            <div className="calendar-selected">
              <p>{selectedCalendarPost.status}</p>
              <button className="btn subtle" type="button" onClick={() => setNotice({ type: 'success', message: 'Post Now edit mode next routing phase mein open hoga.' })}>Open in Post Now</button>
              <button className="btn danger" type="button" onClick={() => setNotice({ type: 'success', message: 'Calendar post delete action ready. Backend delete endpoint next phase mein attach hoga.' })}>Delete</button>
            </div>
          ) : (
            <div className="empty-box compact-empty"><strong>Select a post</strong><small>Click any calendar post to edit/delete.</small></div>
          )}
        </div>
      </aside>
    </section>
  );
}

function Messaging({ filteredInbox, inboxFilter, selectedInbox, selectedInboxId, setNotice, setInboxFilter, setSelectedInboxId }) {
  const [replyDraft, setReplyDraft] = useState('');
  const [sentReplies, setSentReplies] = useState({});
  const [networkFilter, setNetworkFilter] = useState('All platforms');
  const visibleInbox = filteredInbox.filter((item) => networkFilter === 'All platforms' || item.network === networkFilter);
  const selectedReplies = sentReplies[selectedInbox.id] || [];
  useEffect(() => {
    setReplyDraft(localStorage.getItem(`easten-reply-${selectedInbox.id}`) || '');
  }, [selectedInbox.id]);

  const saveReply = () => {
    if (!replyDraft.trim()) {
      setNotice({ type: 'warning', message: 'Save karne ke liye reply likho.' });
      return;
    }

    localStorage.setItem(`easten-reply-${selectedInbox.id}`, replyDraft.trim());
    setNotice({ type: 'success', message: 'Reply draft saved.' });
  };
  const sendReply = () => {
    if (!replyDraft.trim()) {
      setNotice({ type: 'warning', message: 'Send karne ke liye reply likho.' });
      return;
    }

    setSentReplies((current) => ({
      ...current,
      [selectedInbox.id]: [
        ...(current[selectedInbox.id] || []),
        {
          id: Date.now(),
          text: replyDraft.trim()
        }
      ]
    }));
    setReplyDraft('');
    setNotice({ type: 'success', message: `${selectedInbox.network} reply queued/sent in workspace inbox.` });
  };

  return (
    <section className="inbox-layout">
      <div className="glass-panel inbox-list">
        <PanelTitle label="Messaging" title="Unified inbox" action="Auto-routing on" />
        <div className="filter-tabs">
          {['All', 'Unread', 'Follow up', 'Read'].map((filter) => (
            <button
              className={cx(inboxFilter === filter && 'active')}
              key={filter}
              onClick={() => setInboxFilter(filter)}
              type="button"
            >
              {filter}
            </button>
          ))}
        </div>
        <div className="filter-tabs network-tabs">
          {['All platforms', 'Instagram', 'Facebook', 'Google Business', 'LinkedIn'].map((filter) => (
            <button
              className={cx(networkFilter === filter && 'active')}
              key={filter}
              onClick={() => setNetworkFilter(filter)}
              type="button"
            >
              {filter}
            </button>
          ))}
        </div>
        {visibleInbox.map((item) => (
          <button
            className={cx('inbox-item', selectedInboxId === item.id && 'active')}
            key={item.id}
            onClick={() => setSelectedInboxId(item.id)}
            type="button"
          >
            <span>
              <strong>{item.from}</strong>
              <small>{item.network} · {item.time}</small>
            </span>
            <p>{item.body}</p>
            <em>{item.status}</em>
          </button>
        ))}
        {!visibleInbox.length && <div className="empty-box compact-empty"><strong>No messages</strong><small>Selected platform/filter mein messages nahi hain.</small></div>}
      </div>

      <div className="glass-panel conversation">
        <PanelTitle label={selectedInbox.network} title={selectedInbox.from} action={selectedInbox.sentiment} />
        <div className="conversation-body">
          <div className="bubble inbound">{selectedInbox.body}</div>
          <div className="bubble outbound">Thanks for reaching out. I am checking this and will share the details shortly.</div>
          {selectedReplies.map((reply) => (
            <div className="bubble outbound" key={reply.id}>{reply.text}</div>
          ))}
        </div>
        <div className="reply-box">
          <textarea
            value={replyDraft}
            onChange={(event) => setReplyDraft(event.target.value)}
            placeholder="Reply, add saved response, or assign to team..."
          />
          <div>
            <button className="btn subtle" type="button" onClick={saveReply}>Save reply</button>
            <button className="btn primary" type="button" onClick={sendReply}>Send reply</button>
          </div>
        </div>
      </div>

      <div className="glass-panel automation-panel">
        <PanelTitle label="Automation" title="Smart replies" action="Rules" />
        <label className="automation-input">
          <span>Keyword auto reply</span>
          <input placeholder="price, demo, appointment..." />
        </label>
        <div className="rule-card active">
          <strong>DM keyword reply</strong>
          <small>Reply when message contains pricing/demo keywords.</small>
        </div>
        <div className="rule-card">
          <strong>Comments automation</strong>
          <small>Auto reply to comments, tag urgent comments.</small>
        </div>
        <div className="rule-card">
          <strong>Google review response</strong>
          <small>Prepare polite review replies by rating.</small>
        </div>
        <div className="rule-card">
          <strong>Follow-up filter</strong>
          <small>Show conversations older than 24 hours.</small>
        </div>
      </div>
    </section>
  );
}

function Reports({ platformOptions = [], reportPlatform, reportRange, setNotice, setReportPlatform, setReportRange }) {
  const connectedReportLabels = platformOptions
    .filter((platform) => platform.connected)
    .map((platform) => platform.id === 'google' ? 'Google' : platform.label)
    .filter((label) => reportSeries.some((series) => series.label === label) || label === 'YouTube');
  const reportChoices = ['All', ...connectedReportLabels.filter((item, index, arr) => arr.indexOf(item) === index)];
  const activeSeries = reportPlatform === 'All'
    ? reportSeries.filter((series) => connectedReportLabels.includes(series.label))
    : reportSeries.filter((series) => series.label === reportPlatform && connectedReportLabels.includes(series.label));
  const visibleSeries = activeSeries.length ? activeSeries : reportSeries.filter((series) => connectedReportLabels.includes(series.label));
  const visibleTopPosts = topPosts.filter((post) => reportChoices.includes(post.platform));
  const prepareMonthlyReport = async (mode) => {
    const reportPayload = {
      generatedAt: new Date().toISOString(),
      platform: reportPlatform,
      range: reportRange,
      summary: {
        followersGrowth: '+12.8%',
        reach: '184K',
        engagement: '8.4%',
        adSpend: '₹18.4K'
      },
      topPosts: visibleTopPosts,
      series: visibleSeries
    };

    if (mode === 'Download') {
      const blob = new Blob([JSON.stringify(reportPayload, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `easten-social-report-${reportRange.toLowerCase()}.json`;
      link.click();
      URL.revokeObjectURL(url);
    }

    if (mode === 'Client share' && navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(`${window.location.origin}/#client-report-${reportRange.toLowerCase()}`);
      } catch (error) {
        setNotice({ type: 'warning', message: 'Client report ready. Browser ne clipboard copy block kar diya.' });
        return;
      }
    }

    setNotice({
      type: 'success',
      message: `${mode} report ready: followers, audience growth, ad spend, top 10 posts, top 5 posts, and platform charts included.`
    });
  };

  return (
    <section className="reports-grid">
      <div className="glass-panel report-main">
        <div className="panel-head">
          <div>
            <p className="kicker">Reports</p>
            <h2>Growth intelligence</h2>
          </div>
          <div className="report-controls">
            <select value={reportPlatform} onChange={(event) => setReportPlatform(event.target.value)}>
              {reportChoices.map((item) => (
                <option key={item}>{item}</option>
              ))}
            </select>
            <div className="toggle-pair">
              {['7D', '30D', '90D', '1Y'].map((range) => (
                <button className={cx(reportRange === range && 'active')} key={range} onClick={() => setReportRange(range)} type="button">{range}</button>
              ))}
            </div>
          </div>
        </div>

        <div className="kpi-row">
          <Metric label="Followers" value="+12.8%" note="vs previous range" />
          <Metric label="Reach" value="184K" note="Organic + paid" />
          <Metric label="Engagement" value="8.4%" note="Weighted average" />
        </div>

        <div className="analytics-board">
          <div className="chart-card">
            <div className="chart-topline">
              <span>Audience growth</span>
              <strong>+18.6%</strong>
            </div>
            <svg viewBox="0 0 640 240" role="img" aria-label="Growth line chart">
              <defs>
                <linearGradient id="areaFill" x1="0" x2="0" y1="0" y2="1">
                  <stop offset="0%" stopColor="#24a36a" stopOpacity="0.24" />
                  <stop offset="100%" stopColor="#24a36a" stopOpacity="0" />
                </linearGradient>
              </defs>
              {[42, 44, 47, 51, 57, 64, 72].map((tick, index) => (
                <line className="grid-line" key={tick} x1="0" x2="640" y1={34 + index * 30} y2={34 + index * 30} />
              ))}
              <polygon
                className="area-line"
                points={`0,228 ${linePoints([34, 42, 49, 45, 66, 72, 81], 640, 210)} 640,228`}
              />
              {visibleSeries.map((series) => (
                <polyline
                  fill="none"
                  key={series.label}
                  points={linePoints(series.values, 640, 210)}
                  stroke={series.color}
                />
              ))}
            </svg>
            <div className="chart-axis">
              <span>Week 1</span>
              <span>Week 2</span>
              <span>Week 3</span>
              <span>Week 4</span>
            </div>
          </div>

          <div className="platform-breakdown">
            {reportSeries.map((series) => {
              const latest = series.values[series.values.length - 1];
              const first = series.values[0];
              return (
                <div className="breakdown-row" key={series.label} style={{ '--platform': series.color }}>
                  <span />
                  <strong>{series.label}</strong>
                  <em>{latest}K</em>
                  <small>+{latest - first}K growth</small>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="glass-panel">
        <PanelTitle label="Top posts" title="Best performers" action="By platform" />
        <div className="top-posts">
            {visibleTopPosts.map((post) => (
            <div className="top-post" key={post.rank}>
              <span>{post.rank}</span>
              <div>
                <strong>{post.post}</strong>
                <small>{post.platform} · {post.reach} reach · {post.leads} leads</small>
              </div>
              <em>{post.engagement}</em>
            </div>
          ))}
        </div>
        <div className="report-export">
          <button className="btn subtle" type="button" onClick={() => prepareMonthlyReport('Download')}>Download monthly report</button>
          <button className="btn primary" type="button" onClick={() => prepareMonthlyReport('Client share')}>Share client report</button>
        </div>
        <div className="report-pack">
          <span>Monthly pack</span>
          <small>Followers growth</small>
          <small>Audience growth</small>
          <small>Ad spend</small>
          <small>Top 10 posts</small>
          <small>Top 5 winners</small>
        </div>
      </div>
    </section>
  );
}

function Profiles({ connectedPages, connectFacebook, connectGoogle, connectInstagram, facebookStatus, googleStatus, instagramStatus, lastSync, setNotice }) {
  const instagramAccount = instagramStatus?.accounts?.[0] || null;
  const displayProfiles = profileCards.map((profile) => {
    if (profile.platform === 'Facebook') {
      const page = connectedPages[0] || null;
      return {
        ...profile,
        handle: page?.name || 'Not connected',
        health: page ? 'Active' : 'Disconnected',
        sync: page?.updatedAt ? new Date(page.updatedAt).toLocaleString() : 'Connect now'
      };
    }

    if (profile.platform === 'Google Business') {
      const account = googleStatus?.googleBusiness?.accounts?.[0] || null;
      const hasGoogleLogin = Boolean(googleStatus?.connected);
      const hasBusinessScope = Boolean(googleStatus?.googleBusiness?.hasScope);
      const businessError = googleStatus?.googleBusiness?.error;
      const needsApiApproval = Boolean(googleStatus?.googleBusiness?.needsApiApproval);
      return {
        ...profile,
        handle: account?.accountName || account?.name || (hasGoogleLogin ? (needsApiApproval ? 'API approval needed' : hasBusinessScope ? 'Google connected, no business found' : 'Permission needed') : 'Not connected'),
        health: googleStatus?.googleBusiness?.connected ? 'Active' : 'Disconnected',
        sync: businessError || (googleStatus?.profile?.updatedAt ? new Date(googleStatus.profile.updatedAt).toLocaleString() : 'Connect now')
      };
    }

    if (profile.platform === 'YouTube') {
      const channel = googleStatus?.youtube?.channels?.[0] || null;
      return {
        ...profile,
        handle: channel?.title || 'Not connected',
        health: googleStatus?.youtube?.connected ? 'Active' : 'Disconnected',
        sync: googleStatus?.profile?.updatedAt ? new Date(googleStatus.profile.updatedAt).toLocaleString() : 'Connect now'
      };
    }

    if (profile.platform !== 'Instagram') return profile;

    return {
      ...profile,
      handle: instagramAccount?.username ? `@${instagramAccount.username}` : 'Not connected',
      health: instagramStatus?.connected ? 'Active' : 'Disconnected',
      sync: instagramAccount?.updatedAt ? new Date(instagramAccount.updatedAt).toLocaleString() : 'Connect now'
    };
  });

  const connectProfile = (profile) => {
    if (profile.platform === 'Google Business') {
      connectGoogle('google-business');
      return;
    }

    if (profile.platform === 'YouTube') {
      connectGoogle('youtube');
      return;
    }

    if (profile.platform === 'Instagram') {
      connectInstagram();
      return;
    }

    if (profile.platform === 'Facebook') {
      connectFacebook();
      return;
    }

    setNotice({ type: 'warning', message: `${profile.platform} connection next phase mein add hoga.` });
  };
  const editProfile = (profile) => {
    setNotice({ type: 'success', message: `${profile.platform} profile editor ready. ${profile.handle} selected.` });
  };
  const disconnectProfile = (profile) => {
    setNotice({
      type: 'warning',
      message: `${profile.platform} disconnect flow ready hai. Token revoke/delete backend step next mein attach hoga.`
    });
  };

  return (
    <section className="profiles-grid">
      <div className="glass-panel profile-live">
        <PanelTitle label="Profiles" title="Connected accounts" action={facebookStatus?.loggedIn ? 'Session active' : 'Login needed'} />
        <div className="profile-cards">
          {displayProfiles.map((profile) => (
            <div className="profile-card" key={profile.platform} style={{ '--platform': profile.color }}>
              <span>{profile.platform.slice(0, 2)}</span>
              <div>
                <strong>{profile.platform}</strong>
                <small>{profile.handle}</small>
              </div>
              <em>{profile.health}</em>
              {profile.health !== 'Active' ? (
                <button type="button" onClick={() => connectProfile(profile)}>Connect</button>
              ) : (
                <div className="profile-actions">
                  <button type="button" onClick={() => editProfile(profile)}>Edit</button>
                  <button className="danger" type="button" onClick={() => disconnectProfile(profile)}>Disconnect</button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="glass-panel profile-side">
        <PanelTitle label="Facebook backend" title="Live sync" action={`${connectedPages.length} pages`} />
        <div className="live-pages">
          {googleStatus?.connected && (
            <div className="page-chip">
              <strong>Google: {googleStatus.profile?.email || 'connected'}</strong>
              <small>
                {googleStatus.googleBusiness?.accounts?.length || 0} business accounts · {googleStatus.youtube?.channels?.length || 0} YouTube channels
              </small>
            </div>
          )}
          {googleStatus?.googleBusiness?.error && (
            <p className="sync-warning">
              Google Business issue: {googleStatus.googleBusiness.needsApiApproval ? 'Google API quota/access approval needed for this project.' : googleStatus.googleBusiness.error}
            </p>
          )}
          {googleStatus?.youtube?.error && (
            <p className="sync-warning">YouTube issue: {googleStatus.youtube.error}</p>
          )}
          {instagramStatus?.connected && instagramStatus.accounts.map((account) => (
            <div className="page-chip" key={account.instagramBusinessId}>
              <strong>Instagram: @{account.username || account.name || 'connected'}</strong>
              <small>IG Business ID {account.instagramBusinessId}</small>
            </div>
          ))}
          {lastSync && (
            <div className="page-chip">
              <strong>Meta sync: {lastSync.pagesFound || 0} pages · {lastSync.instagramAccountsFound || 0} Instagram</strong>
              <small>
                Source {lastSync.pageSource || 'me/accounts'}
                {lastSync.missingPermissions?.length ? ` · Missing ${lastSync.missingPermissions.join(', ')}` : ''}
              </small>
            </div>
          )}
          {connectedPages.length ? connectedPages.map((page) => (
            <div className="page-chip" key={page.pageId}>
              <strong>{page.name}</strong>
              <small>{page.pageId}</small>
            </div>
          )) : (
            <div className="empty-box">
              <strong>No Facebook page synced</strong>
              <small>Connect the Facebook account that owns the page.</small>
            </div>
          )}
        </div>
        {lastSync?.errorMessage && <p className="sync-warning">{lastSync.errorMessage}</p>}
        <button className="btn primary full" type="button" onClick={connectFacebook}>Connect or reconnect Facebook</button>
        <button className="btn subtle full" type="button" onClick={connectInstagram}>Connect Instagram Business</button>
        <button className="btn subtle full" type="button" onClick={() => connectGoogle('google-business')}>Connect Google Business</button>
        <button className="btn subtle full" type="button" onClick={() => connectGoogle('youtube')}>Connect YouTube</button>
      </div>
    </section>
  );
}

function BulkScheduling({ bulkRows, setNotice, setBulkRows, writeWithAI }) {
  const addRows = () => {
    setBulkRows((current) => [
      {
        id: Date.now(),
        date: '2026-07-18',
        platform: 'Facebook + Instagram + LinkedIn',
        caption: 'Imported campaign row',
        media: 'image',
        status: 'Ready'
      },
      ...current
    ]);
    setNotice({ type: 'success', message: 'Sample bulk row imported.' });
  };
  const scheduleReadyRows = () => {
    const readyCount = bulkRows.filter((row) => row.status !== 'Scheduled').length;
    setBulkRows((current) => current.map((row) => ({
      ...row,
      status: row.status === 'Scheduled' ? row.status : 'Scheduled'
    })));
    setNotice({ type: 'success', message: `${readyCount} bulk rows marked scheduled and added to planning queue.` });
  };

  return (
    <section className="bulk-grid">
      <div className="glass-panel">
        <PanelTitle label="Bulk Scheduling" title="Upload, map, approve" action="CSV + media" />
        <div className="upload-zone">
          <strong>Drop CSV, Excel, images, or videos</strong>
          <span>Columns: date, time, platform, caption, media, campaign, approval owner.</span>
          <div>
            <button className="btn primary" type="button" onClick={addRows}>Import sample rows</button>
            <button className="btn subtle" type="button" onClick={writeWithAI}>Auto captions</button>
            <button className="btn subtle" type="button" onClick={scheduleReadyRows}>Schedule ready rows</button>
          </div>
        </div>

        <div className="bulk-options">
          <label><span>Default platforms</span><select><option>Facebook + Instagram</option><option>All connected profiles</option></select></label>
          <label><span>Queue rule</span><select><option>Best time per platform</option><option>Exact CSV time</option></select></label>
          <label><span>Approval</span><select><option>Client approval required</option><option>Auto approve</option></select></label>
        </div>
      </div>

      <div className="glass-panel">
        <PanelTitle label="Imported rows" title={`${bulkRows.length} posts ready`} action="Review" />
        <div className="bulk-table">
          {bulkRows.map((row) => (
            <div className="bulk-row" key={row.id}>
              <span>{row.date}</span>
              <strong>{row.caption}</strong>
              <small>{row.platform} · {row.media}</small>
              <em>{row.status}</em>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Ads({ setNotice }) {
  const [campaigns, setCampaigns] = useState(adCampaigns);
  const [objective, setObjective] = useState('Leads');
  const [budget, setBudget] = useState('1200');
  const [audience, setAudience] = useState('Warm visitors + 10km local');
  const prepareCampaign = () => {
    const newCampaign = {
      id: Date.now(),
      name: `${objective} campaign draft`,
      platform: 'Meta + Google',
      budget: `₹${Number(budget || 0).toLocaleString('en-IN')}/day`,
      spent: '₹0',
      result: 'Ready to launch',
      state: audience
    };

    setCampaigns((current) => [newCampaign, ...current]);
    setNotice({ type: 'success', message: `${objective} campaign prepared with ₹${budget}/day budget.` });
  };

  return (
    <section className="ads-grid">
      <div className="glass-panel">
        <PanelTitle label="Ads" title="Meta + Google control" action="Paid center" />
        <div className="ad-account-grid">
          <div className="ad-account meta">
            <span>Meta</span>
            <strong>₹11,140 spent</strong>
            <small>128 leads · CPL ₹87</small>
          </div>
          <div className="ad-account google">
            <span>Google</span>
            <strong>₹5,110 spent</strong>
            <small>42 calls · Search + local</small>
          </div>
        </div>

        <div className="ad-builder">
          <label><span>Objective</span><select value={objective} onChange={(event) => setObjective(event.target.value)}><option>Leads</option><option>Calls</option><option>Website traffic</option></select></label>
          <label><span>Daily budget</span><input value={budget} onChange={(event) => setBudget(event.target.value)} /></label>
          <label><span>Audience</span><select value={audience} onChange={(event) => setAudience(event.target.value)}><option>Warm visitors + 10km local</option><option>Lookalike audience</option></select></label>
          <button className="btn primary" type="button" onClick={prepareCampaign}>Prepare campaign</button>
        </div>
      </div>

      <div className="glass-panel">
        <PanelTitle label="Campaigns" title="Live performance" action="Optimize" />
        <div className="campaign-list">
          {campaigns.map((campaign) => (
            <div className="campaign-row" key={campaign.id || campaign.name}>
              <div>
                <strong>{campaign.name}</strong>
                <small>{campaign.platform} · {campaign.budget} budget</small>
              </div>
              <span>{campaign.spent}</span>
              <em>{campaign.result}</em>
              <b>{campaign.state}</b>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function PanelTitle({ label, title, action }) {
  return (
    <div className="panel-head">
      <div>
        <p className="kicker">{label}</p>
        <h2>{title}</h2>
      </div>
      <span>{action}</span>
    </div>
  );
}

function Segmented({ label, value, onChange, options }) {
  return (
    <label className="segmented-wrap">
      <span>{label}</span>
      <div className="segmented">
        {options.map((option) => {
          const optionValue = typeof option === 'string' ? option : option.value;
          const optionLabel = typeof option === 'string'
            ? option.charAt(0).toUpperCase() + option.slice(1)
            : option.label;

          return (
            <button
              className={cx(value === optionValue && 'active')}
              key={optionValue}
              onClick={() => onChange(optionValue)}
              type="button"
            >
              {optionLabel}
            </button>
          );
        })}
      </div>
    </label>
  );
}

export default App;
